!function (e, t) {
  for (var n in t) {
    e[n] = t[n];
  }
}(exports, function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 8);
}([function (e, t, n) {
  e.exports = n(10);
}, function (e, t) {
  e.exports = require("lodash");
}, function (e, t) {
  e.exports = require("react-notify-toast");
}, function (e, t) {
  e.exports = require("redux");
}, function (e, t) {
  e.exports = require("redux-thunk");
}, function (e, t) {
  e.exports = require("redux-logger");
}, function (e, t) {
  e.exports = require("react-sortable-hoc");
}, function (e, t) {
  var n = {
    coverageRequests: [{
      id: "1234",
      script: "2234",
      scriptVersion: {
        id: "5667",
        version: "1"
      },
      desk: {
        _id: "asdf1234",
        name: "Julian Jacobs"
      },
      confidentiality: "Public",
      created: new Date("10/8/1965"),
      level: "Detailed",
      client: {
        _id: "gm1234",
        name: "General Motors"
      },
      representation: !0,
      openWriting: !0,
      openDirecting: !1,
      openCasting: !0,
      comments: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    }, {
      id: "1235",
      script: "2235",
      scriptVersion: {
        id: "5667",
        version: "1"
      },
      desk: {
        _id: "asdf1234",
        name: "Julian Jacobs"
      },
      confidentiality: "Private",
      created: new Date("11/8/1965"),
      needed: new Date("11/23/1966"),
      submitted: new Date("11/13/1966"),
      level: "Detailed",
      client: {
        _id: "gm1234",
        name: "General Motors"
      },
      representation: !0,
      openWriting: !0,
      openDirecting: !1,
      openCasting: !0,
      comments: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      assigned: new Date("11/15/1966"),
      started: new Date("11/17/1966"),
      completed: new Date("11/21/1966")
    }, {
      id: "1236",
      script: "2236",
      scriptVersion: {
        id: "5667",
        version: "1"
      },
      desk: {
        _id: "asdf1234",
        name: "Julian Jacobs"
      },
      confidentiality: "Invisible",
      created: new Date("12/8/1965"),
      needed: new Date("12/21/1966"),
      submitted: new Date("12/13/1966"),
      level: "Detailed",
      client: {
        _id: "gm1234",
        name: "General Motors"
      },
      representation: !0,
      openWriting: !0,
      openDirecting: !1,
      openCasting: !0,
      comments: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      assigned: new Date("11/15/1966"),
      started: new Date("11/17/1966"),
      completed: new Date("11/21/1966")
    }, {
      id: "1237",
      script: "2237",
      scriptVersion: {
        id: "5667",
        version: "1"
      },
      desk: {
        _id: "asdf1234",
        name: "Julian Jacobs"
      },
      confidentiality: "Public",
      created: new Date("1/8/1966"),
      needed: new Date("1/23/1966"),
      submitted: new Date("1/13/1966"),
      level: "Detailed",
      client: {
        _id: "gm1234",
        name: "General Motors"
      },
      representation: !0,
      openWriting: !0,
      openDirecting: !1,
      openCasting: !0,
      comments: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      assigned: new Date("1/15/1966"),
      started: new Date("1/17/1966")
    }, {
      id: "1238",
      script: "2238",
      scriptVersion: {
        id: "5667",
        version: "1"
      },
      desk: {
        _id: "asdf1234",
        name: "Julian Jacobs"
      },
      confidentiality: "Invisible",
      created: new Date("2/8/1966"),
      needed: new Date("2/23/1966"),
      level: "Detailed",
      client: {
        _id: "gm1234",
        name: "General Motors"
      },
      representation: !0,
      openWriting: !0,
      openDirecting: !1,
      openCasting: !0,
      comments: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      assigned: new Date("11/15/1966"),
      started: new Date("11/17/1966"),
      completed: new Date("11/21/1966")
    }, {
      id: "1239",
      script: "2239",
      scriptVersion: {
        id: "5667",
        version: "1"
      },
      desk: {
        _id: "asdf1234",
        name: "Julian Jacobs"
      },
      confidentiality: "Private",
      created: new Date("3/8/1966"),
      needed: new Date("3/23/1966"),
      submitted: new Date("3/13/1966"),
      level: "Standard",
      client: {
        _id: "gm1234",
        name: "General Motors"
      },
      representation: !0,
      openWriting: !0,
      openDirecting: !1,
      openCasting: !0,
      comments: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      assigned: new Date("11/15/1966")
    }, {
      id: "1240",
      script: "2240",
      scriptVersion: {
        id: "5667",
        version: "1"
      },
      desk: {
        _id: "asdf1234",
        name: "Julian Jacobs"
      },
      confidentiality: "Public",
      created: new Date("4/8/1966"),
      needed: new Date("4/23/1966"),
      level: "Standard",
      client: {
        _id: "gm1234",
        name: "General Motors"
      },
      representation: !0,
      openWriting: !0,
      openDirecting: !1,
      openCasting: !0,
      comments: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    }, {
      id: "1241",
      script: "2241",
      scriptVersion: {
        id: "5667",
        version: "1"
      },
      desk: {
        _id: "asdf1234",
        name: "Julian Jacobs"
      },
      confidentiality: "Invisible",
      created: new Date("5/8/1966"),
      needed: new Date("5/23/1966"),
      submitted: new Date("5/13/1966"),
      level: "Standard",
      client: {
        _id: "gm1234",
        name: "General Motors"
      },
      representation: !0,
      openWriting: !0,
      openDirecting: !1,
      openCasting: !0,
      comments: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    }, {
      id: "1242",
      script: "2242",
      scriptVersion: {
        id: "5667",
        version: "1"
      },
      desk: {
        _id: "asdf1234",
        name: "Julian Jacobs"
      },
      confidentiality: "Invisible",
      created: new Date("6/8/1966"),
      needed: new Date("6/23/1966"),
      submitted: new Date("6/13/1966"),
      level: "None",
      client: {
        _id: "gm1234",
        name: "General Motors"
      },
      representation: !0,
      openWriting: !0,
      openDirecting: !1,
      openCasting: !0,
      comments: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      assigned: new Date("6/15/1966"),
      started: new Date("6/17/1966")
    }, {
      id: "1243",
      script: "2243",
      scriptVersion: {
        id: "5667",
        version: "1"
      },
      desk: {
        _id: "asdf1234",
        name: "Julian Jacobs"
      },
      confidentiality: "Private",
      created: new Date("7/8/1966"),
      needed: new Date("7/23/1966"),
      submitted: new Date("7/13/1966"),
      level: "None",
      client: {
        _id: "gm1234",
        name: "General Motors"
      },
      representation: !0,
      openWriting: !0,
      openDirecting: !1,
      openCasting: !0,
      comments: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      assigned: new Date("7/15/1966"),
      started: new Date("7/17/1966"),
      completed: new Date("7/21/1966")
    }],
    scripts: [{
      id: "2234",
      title: "2001: A Space Odyssey",
      authors: "Paul Ryan",
      confidentiality: "Public",
      form: "Screenplay",
      studio: "Universal Studios",
      productionCo: "Impossible Dream Entertainment",
      clientMaterial: !0,
      date: new Date("10/8/1965"),
      versions: [{
        id: "5667",
        version: "1",
        pages: "108",
        file: "version1.pdf"
      }, {
        id: "7667",
        version: "2",
        pages: "118",
        file: "version2.pdf"
      }],
      attachments: [{
        person: {
          _id: "1234asdf",
          name: "Clint Eastwood"
        },
        roles: ["Director", "Talent"]
      }, {
        person: {
          _id: "1235asdf",
          name: "Oscar Wilde"
        },
        roles: ["Producer"]
      }]
    }, {
      id: "2235",
      title: "Almost Famous",
      authors: "George Washington",
      confidentiality: "Private",
      form: "Screenplay",
      studio: "Universal Studios",
      productionCo: "Impossible Dream Entertainment",
      clientMaterial: !0,
      date: new Date("10/8/1965"),
      versions: [{
        id: "5667",
        version: "1",
        pages: "108",
        file: "version1.pdf"
      }, {
        id: "7667",
        version: "2",
        pages: "118",
        file: "version2.pdf"
      }],
      attachments: [{
        person: {
          _id: "1234asdf",
          name: "Clint Eastwood"
        },
        roles: ["Director", "Talent"]
      }, {
        person: {
          _id: "1235asdf",
          name: "Oscar Wilde"
        },
        roles: ["Producer"]
      }]
    }, {
      id: "2236",
      title: "Batman",
      authors: "Ryan Smith",
      confidentiality: "Invisible",
      form: "Screenplay",
      studio: "Universal Studios",
      productionCo: "Impossible Dream Entertainment",
      clientMaterial: !0,
      date: new Date("10/8/1965"),
      versions: [{
        id: "5667",
        version: "1",
        pages: "108",
        file: "version1.pdf"
      }, {
        id: "7667",
        version: "2",
        pages: "118",
        file: "version2.pdf"
      }],
      attachments: [{
        person: {
          _id: "1234asdf",
          name: "Clint Eastwood"
        },
        roles: ["Director", "Talent"]
      }, {
        person: {
          _id: "1235asdf",
          name: "Oscar Wilde"
        },
        roles: ["Producer"]
      }]
    }, {
      id: "2237",
      title: "Citizen Kane",
      authors: "Julian Rogers",
      confidentiality: "Public",
      form: "Screenplay",
      studio: "Universal Studios",
      productionCo: "Impossible Dream Entertainment",
      clientMaterial: !0,
      date: new Date("10/8/1965"),
      versions: [{
        id: "5667",
        version: "1",
        pages: "108",
        file: "version1.pdf"
      }, {
        id: "7667",
        version: "2",
        pages: "118",
        file: "version2.pdf"
      }],
      attachments: [{
        person: {
          _id: "1234asdf",
          name: "Clint Eastwood"
        },
        roles: ["Director", "Talent"]
      }, {
        person: {
          _id: "1235asdf",
          name: "Oscar Wilde"
        },
        roles: ["Producer"]
      }]
    }, {
      id: "2238",
      title: "Die Hard",
      authors: "Amanda Knope",
      confidentiality: "Invisible",
      form: "Screenplay",
      studio: "Universal Studios",
      productionCo: "Impossible Dream Entertainment",
      clientMaterial: !0,
      date: new Date("10/8/1965"),
      versions: [{
        id: "5667",
        version: "1",
        pages: "108",
        file: "version1.pdf"
      }, {
        id: "7667",
        version: "2",
        pages: "118",
        file: "version2.pdf"
      }],
      attachments: [{
        person: {
          _id: "1234asdf",
          name: "Clint Eastwood"
        },
        roles: ["Director", "Talent"]
      }, {
        person: {
          _id: "1235asdf",
          name: "Oscar Wilde"
        },
        roles: ["Producer"]
      }]
    }, {
      id: "2239",
      title: "Exorcist, The",
      authors: "Elizabeth Jacobs",
      confidentiality: "Private",
      form: "Screenplay",
      studio: "Universal Studios",
      productionCo: "Impossible Dream Entertainment",
      clientMaterial: !0,
      date: new Date("10/8/1965"),
      versions: [{
        id: "5667",
        version: "1",
        pages: "108",
        file: "version1.pdf"
      }, {
        id: "7667",
        version: "2",
        pages: "118",
        file: "version2.pdf"
      }],
      attachments: [{
        person: {
          _id: "1234asdf",
          name: "Clint Eastwood"
        },
        roles: ["Director", "Talent"]
      }, {
        person: {
          _id: "1235asdf",
          name: "Oscar Wilde"
        },
        roles: ["Producer"]
      }]
    }, {
      id: "2240",
      title: "Fargo",
      authors: "Marie Miller",
      confidentiality: "Public",
      form: "Screenplay",
      studio: "Universal Studios",
      productionCo: "Impossible Dream Entertainment",
      clientMaterial: !0,
      date: new Date("10/8/1965"),
      versions: [{
        id: "5667",
        version: "1",
        pages: "108",
        file: "version1.pdf"
      }, {
        id: "7667",
        version: "2",
        pages: "118",
        file: "version2.pdf"
      }],
      attachments: [{
        person: {
          _id: "1234asdf",
          name: "Clint Eastwood"
        },
        roles: ["Director", "Talent"]
      }, {
        person: {
          _id: "1235asdf",
          name: "Oscar Wilde"
        },
        roles: ["Producer"]
      }]
    }, {
      id: "2241",
      title: "Ghostbusters",
      authors: "Eli Robinson",
      confidentiality: "Invisible",
      form: "Screenplay",
      studio: "Universal Studios",
      productionCo: "Impossible Dream Entertainment",
      clientMaterial: !0,
      date: new Date("10/8/1965"),
      versions: [{
        id: "5667",
        version: "1",
        pages: "108",
        file: "version1.pdf"
      }, {
        id: "7667",
        version: "2",
        pages: "118",
        file: "version2.pdf"
      }],
      attachments: [{
        person: {
          _id: "1234asdf",
          name: "Clint Eastwood"
        },
        roles: ["Director", "Talent"]
      }, {
        person: {
          _id: "1235asdf",
          name: "Oscar Wilde"
        },
        roles: ["Producer"]
      }]
    }, {
      id: "2242",
      title: "Harry Potter",
      authors: "Monte Cristo",
      confidentiality: "Invisible",
      form: "Screenplay",
      studio: "Universal Studios",
      productionCo: "Impossible Dream Entertainment",
      clientMaterial: !0,
      date: new Date("10/8/1965"),
      versions: [{
        id: "5667",
        version: "1",
        pages: "108",
        file: "version1.pdf"
      }, {
        id: "7667",
        version: "2",
        pages: "118",
        file: "version2.pdf"
      }],
      attachments: [{
        person: {
          _id: "1234asdf",
          name: "Clint Eastwood"
        },
        roles: ["Director", "Talent"]
      }, {
        person: {
          _id: "1235asdf",
          name: "Oscar Wilde"
        },
        roles: ["Producer"]
      }]
    }, {
      id: "2243",
      title: "I, Robot",
      authors: "Jorge Vidziunas",
      confidentiality: "Private",
      form: "Screenplay",
      studio: "Universal Studios",
      productionCo: "Impossible Dream Entertainment",
      clientMaterial: !0,
      date: new Date("10/8/1965"),
      versions: [{
        id: "5667",
        version: "1",
        pages: "108",
        file: "version1.pdf"
      }, {
        id: "7667",
        version: "2",
        pages: "118",
        file: "version2.pdf"
      }],
      attachments: [{
        person: {
          _id: "1234asdf",
          name: "Clint Eastwood"
        },
        roles: ["Director", "Talent"]
      }, {
        person: {
          _id: "1235asdf",
          name: "Oscar Wilde"
        },
        roles: ["Producer"]
      }]
    }]
  };
  n.coverageRequests.forEach(function (e) {
    e.script = n.scripts.find(function (t) {
      return t.id === e.script;
    });
  }), e.exports = n;
}, function (e, t, n) {
  n(9), e.exports = n(11);
}, function (e, t) {
  e.exports = require("babel-polyfill");
}, function (e, t) {
  e.exports = require("regenerator-runtime");
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(3),
      o = n(4),
      i = n.n(o),
      a = n(5),
      s = n.n(a);

  function c(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function u(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {},
          r = Object.keys(n);
      "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
        return Object.getOwnPropertyDescriptor(n, e).enumerable;
      }))), r.forEach(function (t) {
        c(e, t, n[t]);
      });
    }

    return e;
  }

  function d(e, t, n, r, o) {
    return function (i, a) {
      var s = a().user.user,
          c = a().deployOptions.apiServerUrl,
          u = "GET" !== n,
          d = o && o.map(function (e) {
        return "".concat(Object.keys(e)[0], "=").concat(Object.values(e)[0]);
      }).join("&"),
          l = o ? t + "?" + d : t,
          p = "".concat(c).concat(l),
          f = u ? JSON.stringify(r) : void 0,
          m = s.authorization.scripts,
          g = Sr("SET_SCRIPT_AUTHORIZATION", "/authorization", "POST", null, null),
          v = function v(e, t, n) {
        return n || null == e ? t.then(function (e) {
          return e.data.token;
        }) : Promise.resolve(e);
      },
          y = function y(e) {
        var t = {
          Authorization: "Bearer " + e,
          Accept: "application/json",
          "Content-Type": "application/json"
        };
        return window.fetch(p, {
          method: n,
          body: f,
          headers: new window.Headers(t),
          mode: "cors",
          cache: "default",
          redirect: "follow"
        });
      },
          E = function E(t) {
        return t.json().then(function (n) {
          return i({
            type: e,
            body: n,
            payload: r,
            query: o,
            url: t.url,
            status: t.status,
            headers: t.headers,
            ok: t.ok,
            isLoading: !1
          });
        }, function (n) {
          return i({
            type: e,
            error: n,
            payload: r,
            query: o,
            url: t.url,
            status: t.status,
            headers: t.headers,
            parseError: !0,
            isLoading: !1
          });
        });
      };

      return v(m, g, !1).then(function (t) {
        return i({
          type: e,
          url: p,
          payload: r,
          query: o,
          isLoading: !0
        }), y(t).then(function (e) {
          return "401" === e.status ? v(m, g, !0).then(function (e) {
            return y(e).then(function (e) {
              return E(e);
            });
          }) : E(e);
        }).catch(function (t) {
          return i({
            type: e,
            error: t,
            url: p,
            payload: r,
            query: o,
            failed: !0,
            isLoading: !1
          });
        });
      });
    };
  }

  var l = {
    search: "AD_GROUP_SEARCH",
    details: "AD_GROUP_DETAILS"
  };

  function p(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return d(l.search, "/scripts/roles/ad-groups/".concat(e), "GET", {
      isExecute: t
    });
  }

  function f(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return d(l.details, "/scripts/roles/ad-groups?groupPrefix=".concat(encodeURIComponent(e)), "GET", {
      isExecute: t
    });
  }

  var m = {
    groupList: [],
    groupDetails: {},
    isLoading: !0
  };
  var g = n(0),
      v = n.n(g);

  function y(e, t, n, r, o, i, a) {
    try {
      var s = e[i](a),
          c = s.value;
    } catch (e) {
      return void n(e);
    }

    s.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function E(e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, o) {
        var i = e.apply(t, n);

        function a(e) {
          y(i, r, o, a, s, "next", e);
        }

        function s(e) {
          y(i, r, o, a, s, "throw", e);
        }

        a(void 0);
      });
    };
  }

  function _(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  var h = function () {
    function e(t) {
      var n = t.path,
          r = t.query;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.path = n, this.query = r;
    }

    return function (e, t, n) {
      t && _(e.prototype, t), n && _(e, n);
    }(e, [{
      key: "list",
      value: function value(e, t) {
        return t = t || this.query, ne(e, this.path, "GET", null, t);
      }
    }, {
      key: "create",
      value: function value(e, t, n) {
        return n = n || this.query, ne(e, this.path, "POST", t, n);
      }
    }, {
      key: "update",
      value: function value(e, t, n, r) {
        return ne(e, "".concat(this.path, "/").concat(t), "PATCH", n, r = r || this.query);
      }
    }, {
      key: "get",
      value: function value(e, t, n) {
        return ne(e, "".concat(this.path, "/").concat(t), "GET", null, n = n || this.query);
      }
    }, {
      key: "delete",
      value: function value(e, t) {
        return ne(e, "".concat(this.path, "/").concat(t), "DELETE");
      }
    }]), e;
  }(),
      T = new h({
    path: "/address"
  }),
      C = new h({
    path: "/archive"
  });

  C.search = function (e, t) {
    return ne(e, "/archive", "GET", null, t = t || (void 0).query);
  };

  var P = new h({
    path: "/call_todo",
    query: [{
      $populate: "recipientId"
    }, {
      $populate: "contactId"
    }]
  }),
      R = new h({
    path: "/change"
  }),
      S = new h({
    path: "/company"
  }),
      b = new h({
    path: "/contact"
  }),
      O = new h({
    path: "/data_request"
  }),
      A = new h({
    path: "/desk"
  }),
      L = new h({
    path: "/filter"
  }),
      I = new h({
    path: "/job"
  }),
      D = new h({
    path: "/person",
    query: [{
      $populate: "contacts"
    }, {
      $populate: "addresses"
    }, {
      $populate: "companyId"
    }]
  });
  D.search = function (e, t) {
    return ne(e, "/person", "GET", null, t = t || (void 0).query);
  }, D.searchOutlook = function (e, t) {
    return ne(e, "/o365", "GET", null, t = t || (void 0).query);
  }, D.merge = function (e, t) {
    return ne(e, "/merge", "POST", t, []);
  }, D.uploadContacts = function (e, t) {
    return ne(e, "/uploadContacts", "POST", t, []);
  };
  var j = new h({
    path: "/project"
  }),
      w = new h({
    path: "/project_casting"
  }),
      F = new h({
    path: "/project_note"
  }),
      N = new h({
    path: "/project_role"
  }),
      k = new h({
    path: "/project_script"
  }),
      q = new h({
    path: "/project_submission"
  }),
      U = new h({
    path: "/project_tracking"
  }),
      J = new h({
    path: "/relationship"
  }),
      x = new h({
    path: "/status"
  }),
      $ = (new h({
    path: "/telemetry"
  }), new h({
    path: "/user",
    query: [{
      $populate: "deskIds"
    }, {
      $populate: "personId"
    }]
  })),
      M = n(1),
      G = n(6),
      H = {
    redirect: "REDIRECT",
    invalidate: "INVALIDATE",
    loadUser: "LOAD_USER",
    setUser: "SET_USER",
    setDesk: "SET_DESK",
    setAuth: "SET_AUTH",
    statusEdit: "EDIT_STATUES",
    status: "LIST_STATUES",
    updateDeskSettings: "UPDATE_DESK_SETTINGS",
    updateStatus: "UPDATE_STATUS",
    moveStatus: "MOVE_STATUS"
  };

  function V(e, t, n, r) {
    var o = "".concat(r).concat("/auth/azure");
    n && (o += "?redirect=", o += n), window.location = o;
  }

  function B() {
    return {
      type: H.invalidate
    };
  }

  function W(e) {
    return $.get(H.loadUser, e);
  }

  function z(e) {
    return {
      type: H.setDesk,
      desk: e
    };
  }

  function Q(e, t, n) {
    var r = u({}, e.settings, c({}, t, n));
    return A.update(H.updateDeskSettings, e._id, u({}, e, {
      settings: r
    }));
  }

  function K(e, t, n) {
    return {
      type: H.updateStatus,
      index: e,
      field: t,
      value: n
    };
  }

  function Y(e) {
    return x.create(H.statusEdit, {
      statuses: e
    });
  }

  function Z(e, t) {
    return {
      type: H.moveStatus,
      oldIndex: e,
      newIndex: t
    };
  }

  function X(e) {
    return x.list(H.status, [{
      deskId: e
    }]);
  }

  function ee(e) {
    return {
      type: H.setAuth,
      auth: e
    };
  }

  var te = {
    user: null,
    desk: null,
    status: [],
    isLoading: !1
  };

  function ne(e, t, n, r, o) {
    return function () {
      var i = E(v.a.mark(function i(a, s) {
        var c, u, d, l, p, f, m, g, y, E;
        return v.a.wrap(function (i) {
          for (;;) {
            switch (i.prev = i.next) {
              case 0:
                if (!(c = new URLSearchParams(window.location.search)).has("token")) {
                  i.next = 5;
                  break;
                }

                return localStorage.setItem("uta.auth", c.get("token")), i.next = 5, a(ee(c.get("token")));

              case 5:
                return u = s().user.user, d = s().deployOptions.apiServerUrl, l = "GET" !== n, p = o && o.map(function (e) {
                  return "".concat(Object.keys(e)[0], "=").concat(Object.values(e)[0]);
                }).join("&"), f = o ? t + "?" + p : t, m = "".concat(d).concat(f), g = l ? JSON.stringify(r) : void 0, !(y = u.auth) && c.has("token") && (y = c.get("token")), E = {
                  Authorization: "JWT " + y,
                  Accept: "application/json",
                  "Content-Type": "application/json"
                }, a({
                  type: e,
                  url: m,
                  payload: r,
                  query: o,
                  isLoading: !0
                }), i.abrupt("return", window.fetch(m, {
                  method: n,
                  body: g,
                  headers: new window.Headers(E),
                  mode: "cors",
                  cache: "default",
                  redirect: "follow"
                }).then(function (t) {
                  return 401 !== t.status || window.location.pathname.includes("login") || (window.location = "/login"), t.json().then(function (n) {
                    return 401 !== t.status || window.location.pathname.includes("login") || (a(B()), window.location = "/login"), a({
                      type: e,
                      body: n,
                      payload: r,
                      query: o,
                      url: t.url,
                      status: t.status,
                      headers: t.headers,
                      ok: t.ok,
                      isLoading: !1
                    });
                  }, function (n) {
                    return a({
                      type: e,
                      error: n,
                      payload: r,
                      query: o,
                      url: t.url,
                      status: t.status,
                      headers: t.headers,
                      parseError: !0,
                      isLoading: !1
                    });
                  });
                }).catch(function (t) {
                  return a({
                    type: e,
                    error: t,
                    url: m,
                    payload: r,
                    query: o,
                    failed: !0,
                    isLoading: !1
                  });
                }));

              case 17:
              case "end":
                return i.stop();
            }
          }
        }, i, this);
      }));
      return function (e, t) {
        return i.apply(this, arguments);
      };
    }();
  }

  var re = {
    normalizeDesk: "NORMALIZE_DESK",
    phonesheetUtilization: "PHONESHEET_UTILIZATION",
    recordEvent: "RECORD_EVENT"
  };

  function oe() {
    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
    return ne(re.normalizeDesk, "/ghost/desk-normalize", "POST", {
      isExecute: e
    });
  }

  function ie() {
    return ne(re.phonesheetUtilization, "/casper/phonesheet-utilization", "POST");
  }

  function ae(e, t, n, r, o, i) {
    var a = {
      data: o,
      tag: e,
      source: t,
      level: n,
      userId: i,
      value: r
    };
    return ne(re.recordEvent, "/telemetry", "POST", a);
  }

  var se = {
    deskStatus: {
      isLoading: !0
    },
    phonesheetUtilization: {
      isLoading: !0
    }
  };
  var ce = {
    listArchive: "LIST_ARCHIVE",
    searchArchive: "SEARCH_ARCHIVE",
    updateArchive: "UPDATE_ARCHIVE",
    clearArchive: "CLEAR_ARCHIVE"
  };

  function ue(e) {
    return function () {
      var t = E(v.a.mark(function t(n) {
        var r;
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                (r = [{
                  $limit: 150
                }]).push({
                  $search: "name|company|contact:".concat(e)
                }), n(C.search(ce.searchArchive, r));

              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function de(e) {
    return ne(ce.listArchive, "/archive", "GET", null, e);
  }

  function le(e) {
    return ne(ce.updateArchive, "/archive/" + e._id, "PUT", e, null);
  }

  function pe() {
    return {
      type: ce.clearArchive
    };
  }

  var fe = {
    archives: [],
    archiveCount: 0,
    archiveFilters: {
      offset: 0,
      itemsPerPage: 50,
      name: ""
    }
  };

  function me(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "00",
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2;
    return "".concat(t).concat(e).slice(-n);
  }

  function ge(e) {
    var t = e.getHours() >= 12 ? "pm" : "am";
    return "".concat(e.getHours() % 12 > 0 ? e.getHours() % 12 : 12, ":").concat(me(e.getMinutes())).concat(t);
  }

  var ve = {
    resetForm: "RESET_FORM",
    clearPerson: "CLEAR_PERSON",
    clearPersonSearch: "CLEAR_PERSON_SEARCH",
    clearContactSearch: "CLEAR_CONTACT_SEARCH",
    updateForm: "UPDATE_FORM",
    searchCompany: "SEARCH_COMPANY",
    searchPerson: "SEARCH_PERSON",
    searchPrivate: "SEARCH_PRIVATE",
    searchOutlook: "SEARCH_OUTLOOK",
    searchResults: "SEARCH_RESULTS",
    searchContact: "SEARCH_CONTACT",
    selectPerson: "SELECT_PERSON",
    selectType: "SELECT_CONTACT_TYPE",
    selectContact: "SELECT_CONTACT",
    editCallTodo: "EDIT_CALL_TODO",
    createPerson: "CREATE_ADHOC_PERSON",
    createCompany: "CREATE_ADHOC_COMPANY",
    createContact: "CREATE_ADHOC_CONTACT",
    createAddress: "CREATE_ADHOC_ADDRESS",
    updatePerson: "UPDATE_PERSON",
    showForm: "SHOW_FORM"
  },
      ye = {
    status: "I",
    name: "",
    type: "Home Phone",
    info: "",
    notes: "",
    externalCompany: "",
    date: null,
    time: "12:00",
    edited: !1,
    showForm: !1,
    person: {
      isLoading: !1,
      results: null,
      selected: null
    },
    outlook: {
      isLoading: !1,
      results: null
    },
    contact: {
      results: null,
      selected: null
    },
    editCallTodo: null
  };

  function Ee(e, t) {
    return function (n, r) {
      if (n({
        type: ve.updateForm,
        field: e,
        value: t
      }), "name" === e && (r().callForm.info || n(he())), "info" === e) {
        var o = r().callForm.person.selected;
        o && n(Se(t, o.contacts));
      }
    };
  }

  function _e() {
    return {
      type: ve.showForm
    };
  }

  function he() {
    return {
      type: ve.clearPerson
    };
  }

  function Te() {
    return {
      type: ve.clearPersonSearch
    };
  }

  function Ce() {
    return {
      type: ve.clearContactSearch
    };
  }

  function Pe() {
    return {
      type: ve.resetForm
    };
  }

  function Re(e, t) {
    return function () {
      var n = E(v.a.mark(function n(r) {
        var o, i, a;
        return v.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return o = [{
                  prefix: e
                }, {
                  desk: t
                }], [{
                  $filter: "name:".concat(e)
                }, {
                  deskId: t
                }], (i = []).push({
                  $search: "".concat(e)
                }, {
                  $emppriority: !0
                }), n.next = 6, r(ne(ve.searchPerson, "/person", "GET", null, i));

              case 6:
                a = n.sent.body.data, r({
                  type: ve.searchResults,
                  data: [].concat(a)
                }), r(D.searchOutlook(ve.searchOutlook, o));

              case 9:
              case "end":
                return n.stop();
            }
          }
        }, n, this);
      }));
      return function (e) {
        return n.apply(this, arguments);
      };
    }();
  }

  function Se(e, t) {
    var n = e ? t.filter(function (t) {
      return t && t.contact && t.contact.includes(e);
    }) : t;
    return {
      type: ve.searchContact,
      results: n
    };
  }

  function be(e) {
    return {
      type: ve.selectPerson,
      person: e
    };
  }

  function Oe(e) {
    return {
      type: ve.selectType,
      contactType: e
    };
  }

  function Ae(e) {
    return {
      type: ve.selectContact,
      contact: e
    };
  }

  function Le(e) {
    return function () {
      var t = E(v.a.mark(function t(n) {
        var r, o;
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return n({
                  type: ve.editCallTodo,
                  callTodo: e
                }), t.next = 3, n(D.get(ve.selectPerson, e.recipientId._id));

              case 3:
                n(Ae(e.contactId)), n(Ee("notes", e.description)), n(Ee("status", e.status)), r = new Date(e.occurrence_date), o = ge(r), n(Ee("date", r)), n(Ee("time", o));

              case 10:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Ie(e) {
    return D.create(ve.createPerson, e);
  }

  function De(e) {
    return S.create(ve.createCompany, e);
  }

  function je(e) {
    return function () {
      var t = E(v.a.mark(function t(n, r) {
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, n(D.update(ve.updatePerson, e._id, e, [{
                  $excludes: "profile_pic"
                }]));

              case 2:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, n) {
        return t.apply(this, arguments);
      };
    }();
  }

  function we(e, t) {
    return function () {
      var t = E(v.a.mark(function t(n, r) {
        var o;
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, n(T.create(ve.createAddress, e));

              case 2:
                return o = t.sent.body, t.abrupt("return", {
                  body: o
                });

              case 4:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, n) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Fe(e, t) {
    return function () {
      var n = E(v.a.mark(function n(r, o) {
        var i, a;
        return v.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.next = 2, r(b.create(ve.createContact, e));

              case 2:
                return i = n.sent.body, (a = u({}, t, {
                  contacts: t.contacts.concat([i._id])
                })).companyId && !a.companyId._id && delete a.companyId, n.next = 7, r(D.update(ve.updatePerson, t._id, a, [{
                  $excludes: "profile_pic"
                }]));

              case 7:
                return n.abrupt("return", {
                  body: i
                });

              case 8:
              case "end":
                return n.stop();
            }
          }
        }, n, this);
      }));
      return function (e, t) {
        return n.apply(this, arguments);
      };
    }();
  }

  var Ne = 500,
      ke = {
    list: "LIST_CALL_TODO",
    create: "CREATE_CALL_TODO",
    update: "UPDATE_CALL_TODO",
    delete: "DELETE_CALL_TODO",
    listByPerson: "LIST_CALL_TODO_BY_PERSON",
    editStatus: "SET_EDIT_STATUS",
    preview: "PREVIEW_CALL",
    loadPerson: "LOAD_PREVIEW_PERSON",
    loadHistory: "LOAD_HISTORY"
  };

  function qe(e) {
    var t = [{
      fieldId: e
    }, {
      $populate: "userId"
    }, {
      "$sort[timestamp]": -1
    }];
    return R.list(ke.loadHistory, t);
  }

  function Ue(e) {
    var t = [{
      $populate: "recipientId"
    }, {
      $populate: "contactId"
    }, {
      $populate: "companyId"
    }, {
      $limit: Ne
    }, {
      "$sort[occurrence_date]": -1
    }, {
      $limit: 500
    }];
    return e && Object.keys(e).forEach(function (n) {
      if (e[n]) {
        var r;

        switch (n) {
          case "startDate":
            r = {
              "occurrence_date[$gte]": e[n]
            };
            break;

          case "endDate":
            r = {
              "occurrence_date[$lte]": e[n]
            };
            break;

          case "query":
            r = {
              $search: "recipientName|companyName|contactInfo:".concat(e[n])
            };
            break;

          case "page":
            r = {
              $skip: 50 * (e[n] - 1)
            };
            break;

          case "desk":
            r = {
              deskId: e[n]
            };
            break;

          case "status":
            r = {
              status: e[n]
            };
            break;

          default:
            r = c({}, n, e[n]);
        }

        t.push(r);
      }
    }), P.list(ke.list, t);
  }

  function Je(e) {
    return function () {
      var t = E(v.a.mark(function t(n) {
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, n(P.create(ke.create, e));

              case 2:
                n(Ue({
                  desk: e.deskId
                }));

              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function xe(e, t) {
    return function () {
      var n = E(v.a.mark(function n(r) {
        return v.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.next = 2, r(P.update(ke.update, e, t));

              case 2:
                r(Ue({
                  desk: t.deskId
                }));

              case 3:
              case "end":
                return n.stop();
            }
          }
        }, n, this);
      }));
      return function (e) {
        return n.apply(this, arguments);
      };
    }();
  }

  function $e(e) {
    return function () {
      var t = E(v.a.mark(function t(n) {
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, n(P.delete(ke.delete, e));

              case 2:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Me(e) {
    return {
      type: ke.preview,
      call: e
    };
  }

  var Ge = {
    calls: {
      callTodos: [],
      status: [],
      isLoading: !1,
      total: null,
      limit: 500,
      skip: 0
    },
    preview: {
      call: null,
      person: null,
      history: [],
      isLoading: !1
    }
  };
  var He = n(2),
      Ve = {
    listPeople: "LIST_PEOPLE",
    listCompany: "LIST_COMPANY",
    createCompany: "CREATE_COMPANY",
    createPerson: "CREATE_PERSON",
    mergePerson: "MERGE_PERSON",
    editCompany: "EDIT_COMPANY",
    deletePeople: "DELETE_PEOPLE",
    deleteCompany: "DELETE_COMPANY",
    searchPerson: "SEARCH_PERSON",
    uploadContacts: "UPLOAD_CONTACTS"
  };

  function Be(e, t) {
    return function () {
      var n = E(v.a.mark(function n(r) {
        var o;
        return v.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                (o = [{
                  $populate: "contacts"
                }, {
                  $populate: "companyId"
                }, {
                  $excludes: "profile_pic"
                }, {
                  offset: 20 * t
                }]).push({
                  $search: "".concat(e)
                }), r(D.search(Ve.searchPerson, o));

              case 3:
              case "end":
                return n.stop();
            }
          }
        }, n, this);
      }));
      return function (e) {
        return n.apply(this, arguments);
      };
    }();
  }

  function We(e) {
    return ne(Ve.listPeople, "/person", "GET", null, e);
  }

  function ze(e) {
    return ne(Ve.listCompany, "/company", "GET", null, e);
  }

  function Qe(e) {
    return S.create(Ve.createCompany, e);
  }

  function Ke(e) {
    return D.merge(Ve.mergePerson, e);
  }

  function Ye(e) {
    return D.create(Ve.createPerson, e);
  }

  function Ze(e) {
    return S.update(Ve.editCompany, e._id, e);
  }

  function Xe(e) {
    return D.delete(Ve.deletePeople, e);
  }

  function et(e) {
    return S.delete(Ve.deleteCompany, e);
  }

  function tt(e) {
    return D.uploadContacts(Ve.uploadContacts, e);
  }

  var nt = {
    people: [],
    peopleCount: 0,
    createdId: "",
    peopleFilters: {
      offset: 0,
      itemsPerPage: 50,
      name: ""
    },
    companies: [],
    companyCount: 0,
    companyFilters: {
      offset: 0,
      itemsPerPage: 50,
      name: ""
    },
    person: {
      isLoading: !1,
      results: null,
      selected: null
    }
  };
  var rt = {
    countNewDataRequests: "DATA_REQUEST_COUNT_NEW_DATA_REQUEST",
    createDataRequest: "DATA_REQUEST_CREATE_DATA_REQUEST",
    loadDataRequests: "DATA_REQUEST_LOAD_DATA_REQUEST",
    removeDataRequest: "DATA_REQUEST_REMOVE_DATA_REQUEST",
    setDataRequestForm: "DATA_REQUEST_SET_DATA_REQUEST_FORM",
    updateDataRequest: "DATA_REQUEST_UPDATE_DATA_REQUEST",
    updateDataRequestForm: "DATA_REQUEST_UPDATE_DATA_REQUEST_FORM"
  };

  function ot() {
    return O.list(rt.countNewDataRequests, [{
      status: "New"
    }]);
  }

  function it(e) {
    return O.create(rt.createDataRequest, e, []);
  }

  function at(e) {
    return O.list(rt.loadDataRequests, e);
  }

  function st(e) {
    return O.delete(rt.removeDataRequest, e);
  }

  function ct(e, t) {
    return O.update(rt.updateDataRequest, e, t);
  }

  var ut = {
    dataRequest: null,
    dataRequests: [],
    total: 0,
    limit: 50,
    skip: 0,
    newDataRequests: 0,
    isLoading: !1
  };

  function dt(e, t, n) {
    return e.body && e.body[n] ? e.body[n] : t[n];
  }

  var lt = {
    apiServerUrl: ""
  };
  var pt = "JULIUS_PROJECTS",
      ft = {
    loadFilters: "FILTERS_LOAD_FILTERS",
    createFilter: "FILTERS_CREATE_FILTER",
    updateFilter: "FILTERS_UPDATE_FILTER",
    setCurrentFilter: "FILTERS_SET_CURRENT_FILTER"
  };

  function mt(e) {
    var t = [{
      deskId: e
    }, {
      service: pt
    }];
    return L.list(ft.loadFilters, t);
  }

  function gt(e) {
    return e.service = pt, L.create(ft.createFilter, e, []);
  }

  function vt(e, t) {
    return L.update(ft.updateFilter, e, t);
  }

  function yt(e) {
    return {
      type: ft.setCurrentFilter,
      newFilterId: e
    };
  }

  var Et = {
    currentFilterIndex: 0,
    filters: []
  };
  var _t = {
    createJob: "JOBS_CREATE_JOBS",
    loadJob: "JOBS_LOAD_JOB",
    loadJobs: "JOBS_LOAD_JOBS",
    removeJob: "JOBS_REMOVE_JOBS",
    updateJob: "JOBS_UPDATE_JOBS"
  };

  function ht(e) {
    return I.create(_t.createJob, e, []);
  }

  function Tt(e) {
    return I.get(_t.loadJob, e);
  }

  function Ct(e) {
    return I.list(_t.loadJobs, e);
  }

  function Pt(e) {
    return I.delete(_t.removeJob, e);
  }

  function Rt(e, t) {
    return I.update(_t.updateJob, e, t);
  }

  var St = {
    job: null,
    jobs: [],
    isLoading: !1
  };
  var bt = {
    client: "Client",
    shared: "Industry Contact",
    employee: "Employee",
    personalContact: "Personal Contact",
    buyer: "Buyer",
    outlook: "Outlook",
    adHoc: "Ad Hoc"
  },
      Ot = {
    searchEmployee: "SEARCH_EMPLOYEEE",
    searchContact: "SEARCH_CONTACT",
    findPerson: "FIND_PERSON"
  },
      At = {
    employees: {
      results: []
    },
    contacts: {
      results: []
    }
  };

  function Lt(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [bt.client, bt.shared];
    return function () {
      var t = E(v.a.mark(function t(r) {
        var o;
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                e && e.length >= 2 ? (o = [{
                  $populate: "contacts"
                }, {
                  $populate: "companyId"
                }, {
                  $populate: "relationships"
                }, {
                  $populate: "addresses"
                }, {
                  $populate: "relationships.personId1"
                }, {
                  $populate: "relationships.personId1.contacts"
                }, {
                  $populate: "relationships.personId1.assistants"
                }, {
                  $populate: "relationships.personId2"
                }, {
                  $populate: "relationships.personId2.contacts"
                }, {
                  $populate: "relationships.personId2.assistants"
                }, {
                  "$sort[initials]": -1
                }, {
                  $limit: 100
                }].concat(n.map(function (e) {
                  return {
                    type: e
                  };
                })), e && o.push({
                  $search: "name|department|location|initials|title|:".concat(e || "")
                }), r(D.search(Ot.searchContact, o))) : r({
                  type: Ot.searchContact,
                  body: {
                    data: []
                  },
                  isLoading: !1
                });

              case 1:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function It(e, t, n) {
    return function () {
      var r = E(v.a.mark(function r(o) {
        var i;
        return v.a.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                if (!(t || e && e.length >= 2)) {
                  r.next = 7;
                  break;
                }

                return i = [{
                  $populate: "contacts"
                }, {
                  $populate: "companyId"
                }, {
                  $populate: "assistants"
                }, {
                  $populate: "assistants.contacts"
                }, {
                  $populate: "managers"
                }, {
                  $populate: "managers.contacts"
                }, {
                  type: bt.employee
                }, {
                  "$sort[name]": 1
                }, {
                  $limit: 50
                }, {
                  $skip: 50 * n
                }], t && t.split(",").map(function (e) {
                  var t = e.split("-");
                  "title" !== t[0] ? i.push({
                    $filter: "location:".concat(t[1])
                  }) : i.push({
                    $filter: "title:".concat(t[1])
                  });
                }), e && i.push({
                  $filter: "name|department|location|initials|title|:".concat(e || "")
                }), r.abrupt("return", o(D.search(Ot.searchEmployee, i)));

              case 7:
                return r.abrupt("return", o({
                  type: Ot.searchEmployee,
                  body: {
                    data: []
                  },
                  isLoading: !1
                }));

              case 8:
              case "end":
                return r.stop();
            }
          }
        }, r, this);
      }));
      return function (e) {
        return r.apply(this, arguments);
      };
    }();
  }

  function Dt(e) {
    return function () {
      var t = E(v.a.mark(function t(n) {
        var r;
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return r = [{
                  $populate: "contacts"
                }, {
                  $populate: "companyId"
                }, {
                  $populate: "relationships"
                }, {
                  $populate: "relationships.personId1"
                }, {
                  $populate: "relationships.personId2"
                }], t.abrupt("return", n(D.get(Ot.findPerson, e, r)));

              case 2:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function jt(e, t) {
    return t.filter(function (e) {
      return null !== e.personId1 && null !== e.personId2;
    }).map(function (t) {
      var n,
          r,
          o = t._id,
          i = t.personId1,
          a = t.personId2,
          s = t.type;
      return e === i._id ? (n = u({}, i, {
        role: "Talent"
      }), r = u({}, a, {
        role: "Talent"
      })) : (n = u({}, a, {
        role: s
      }), r = u({}, i, {
        role: s
      })), {
        _id: o,
        type: r.role,
        person: n,
        party: r
      };
    });
  }

  function wt(e) {
    var t,
        n,
        r = e._id,
        o = e.person,
        i = e.party,
        a = function (e) {
      return e ? e.replace(/ /g, "") : "";
    }(e.type);

    return Ft.includes(a) ? (t = i, n = o) : (t = o, n = i, a = function (e) {
      return e.split("To").reverse().join("To");
    }(a)), {
      _id: r,
      personId1: t,
      personId2: n,
      type: a
    };
  }

  var Ft = ["ResponsibleAgent", "Agent", "Assistant", "Manager", "Attorney", "BusinessPartner", "PersonalManager", "Agency", "Studio", "ProductionCompany", "BusinessAffairs", "Negotiator", "CastingDirector", "Director", "Producer", "ExecProducer", "Publicist", "Network", "UTAPackage", "UTAElement", "Creator", "Buyer"];
  var Nt = {
    addAddress: "PROFILE_ADD_ADDRESS",
    addContact: "PROFILE_ADD_CONTACT",
    addRelation: "PROFILE_ADD_RELATION",
    listByPerson1: "PROFILE_LIST_RELATION_1",
    listByPerson2: "PROFILE_LIST_RELATION_2",
    listCalls: "PROFILE_LIST_CALLS",
    listHistory: "PROFILE_LIST_HISTORY",
    loadPerson: "PROFILE_LOAD_PERSON",
    loadRelation: "PROFILE_LOAD_RELATIONSHIPS",
    publishToContentful: "PROFILE_PUBLISH_TO_CONTENTFUL",
    removeAddress: "PROFILE_REMOVE_ADDRESS",
    removeContact: "PROFILE_REMOVE_CONTACT",
    removeRelation: "PROFILE_REMOVE_RELATION",
    searchCompany: "SEARCH_COMPANY",
    searchPerson: "SEARCH_PERSON",
    updateAddress: "PROFILE_UPDATE_ADDRESS",
    updateContact: "PROFILE_UPDATE_CONTACT",
    updatePerson: "PROFILE_UPDATE_PERSON",
    updateRelation: "PROFILE_UPDATE_RELATIONSHIP"
  };

  function kt(e) {
    return function () {
      var t = E(v.a.mark(function t(n, r) {
        var o, i, a;
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return o = r().profile.person, t.next = 3, n(T.create(Nt.addAddress, e));

              case 3:
                return i = t.sent.body, a = u({}, o, {
                  addresses: o.addresses.concat([i._id])
                }), t.next = 7, n(en(o._id, a));

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, n) {
        return t.apply(this, arguments);
      };
    }();
  }

  function qt(e) {
    return function () {
      var t = E(v.a.mark(function t(n, r) {
        var o, i, a;
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return o = r().profile.person, t.next = 3, n(b.create(Nt.addContact, e));

              case 3:
                return i = t.sent.body, a = u({}, o, {
                  contacts: o.contacts.concat([i._id])
                }), t.next = 7, n(en(o._id, a));

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, n) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Ut(e) {
    return function () {
      var t = E(v.a.mark(function t(n, r) {
        var o;
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                r().profile.person, o = wt(e), n(J.create(Nt.addRelation, o));

              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, n) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Jt(e) {
    var t = [{
      personId1: e
    }, {
      $populate: "personId1"
    }, {
      $populate: "personId2"
    }, {
      $populate: "personId1.contacts"
    }, {
      $populate: "personId2.contacts"
    }, {
      $populate: "personId1.company"
    }, {
      $populate: "personId2.company"
    }];
    return J.list(Nt.listByPerson1, t);
  }

  function xt(e) {
    var t = [{
      personId2: e
    }, {
      $populate: "personId1"
    }, {
      $populate: "personId2"
    }, {
      $populate: "personId1.contacts"
    }, {
      $populate: "personId2.contacts"
    }, {
      $populate: "personId1.company"
    }, {
      $populate: "personId2.company"
    }];
    return J.list(Nt.listByPerson2, t);
  }

  function $t(e) {
    var t = [{
      $limit: 20
    }, {
      recipientId: e
    }, {
      $populate: "recipientId"
    }, {
      $populate: "contactId"
    }, {
      "$sort[timestamp]": -1
    }];
    return P.list(Nt.listCalls, t);
  }

  function Mt(e) {
    var t = [{
      fieldId: e
    }, {
      $populate: "userId"
    }, {
      "$sort[timestamp]": -1
    }];
    return R.list(Nt.listHistory, t);
  }

  function Gt(e) {
    return D.get(Nt.loadPerson, e);
  }

  function Ht(e) {
    return function () {
      var t = E(v.a.mark(function t(n) {
        var r, o, i;
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, n(Jt(e));

              case 2:
                return r = t.sent.body.data, t.next = 5, n(xt(e));

              case 5:
                o = t.sent.body.data, i = jt(e, r.concat(o)), n({
                  type: Nt.loadRelation,
                  relationships: i
                });

              case 8:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Vt(e) {
    return ne(Nt.publishToContentful, "/contentful/publish", "POST", {
      _id: e
    });
  }

  function Bt(e) {
    return function () {
      var t = E(v.a.mark(function t(n, r) {
        var o;
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return o = r().profile.person, t.next = 3, n(T.delete(Nt.removeAddress, e));

              case 3:
                return o = u({}, o, {
                  addresses: o.addresses.filter(function (t) {
                    return t._id !== e;
                  })
                }), t.next = 6, n(en(o._id, o));

              case 6:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, n) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Wt(e) {
    return function () {
      var t = E(v.a.mark(function t(n, r) {
        var o;
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return o = r().profile.person, t.next = 3, n(b.delete(Nt.removeContact, e));

              case 3:
                return o = u({}, o, {
                  contacts: o.contacts.filter(function (t) {
                    return t._id !== e;
                  })
                }), t.next = 6, n(en(o._id, o));

              case 6:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, n) {
        return t.apply(this, arguments);
      };
    }();
  }

  function zt(e) {
    return J.delete(Nt.removeRelation, e);
  }

  function Qt(e) {
    var t = [{
      $search: "name:".concat(e)
    }];
    return ne(Nt.searchCompany, "/company", "GET", null, t);
  }

  function Kt(e, t) {
    var n = "name:".concat(e, "&"),
        r = [{
      $search: n += t ? "type=" + t : "type[$ne]=Ad Hoc"
    }];
    return ne(Nt.searchPerson, "/person", "GET", null, r);
  }

  function Yt(e, t) {
    return T.update(Nt.updateAddress, e, t);
  }

  function Zt(e, t) {
    return b.update(Nt.updateContact, e, t);
  }

  function Xt(e, t) {
    return function (n, r) {
      var o = wt(u({}, r().profile.relationships.find(function (t) {
        return t._id === e;
      }), t));
      n(J.update(Nt.updateRelation, e, o));
    };
  }

  function en(e, t) {
    return D.update(Nt.updatePerson, e, t);
  }

  var tn = {
    person: null,
    history: null,
    calls: null,
    relationships: null,
    isLoading: !1
  };
  var nn = [["1", 1], ["2", 2], ["3", 3], ["4", 4], ["5", 5], ["6", 6], ["7", 7], ["8", 8], ["9", 9], [" 10", 10], [" 11", 11], [" 12", 12], [" 13", 13], [" 14", 14], [" 15", 15], [" 16", 16], [" 17", 17], [" 18", 18], [" 19", 19], [" 20", 20]],
      rn = {
    createProjectCasting: "PROJECT_CASTING_CREATE_PROJECT_CASTING",
    loadProjectCasting: "PROJECT_CASTINGS_LOAD_PROJECT_CASTING",
    loadProjectCastings: "PROJECT_CASTINGS_LOAD_PROJECT_CASTINGS",
    removeProjectCasting: "PROJECT_CASTING_REMOVE_PROJECT_CASTING",
    setProjectCastingForm: "PROJECT_CASTING_SET_PROJECT_CASTING_FORM",
    updateProjectCasting: "PROJECT_CASTING_UPDATE_PROJECT_CASTING",
    updateProjectCastingForm: "PROJECT_CASTING_UPDATE_PROJECT_CASTING_FORM"
  };

  function on(e) {
    return ne(rn.loadProjectCastings, "/project_casting", "GET", null, [{
      projectId: e
    }, {
      $populate: "personId"
    }, {
      $populate: "projectId"
    }]);
  }

  function an(e) {
    return w.get(rn.loadProjectCasting, e, [{
      $populate: "personId"
    }, {
      $populate: "projectId"
    }]);
  }

  function sn(e) {
    return w.create(rn.createProjectCasting, e, []);
  }

  function cn(e) {
    return w.delete(rn.removeProjectCasting, e);
  }

  function un(e, t) {
    return w.update(rn.updateProjectCasting, e, t);
  }

  function dn(e, t) {
    return function (n) {
      n({
        type: rn.updateProjectCastingForm,
        field: e,
        value: t
      });
    };
  }

  function ln(e) {
    var t = nn.find(function (t) {
      return t[1] === e.priority;
    });
    return {
      type: rn.setProjectCastingForm,
      projectCastingForm: {
        _id: e._id,
        _person: e.personId,
        ageMax: e.ageMax,
        ageMin: e.ageMin,
        description: e.description,
        gender: e.gender,
        notes: e.notes,
        name: e.name,
        person: {
          isLoading: !1,
          results: null,
          selected: null
        },
        priority: t && t[0],
        status: e.status,
        type: e.type,
        isClient: e.isClient
      }
    };
  }

  var pn = {
    projectCasting: null,
    projectCastings: [],
    isLoading: !1,
    projectCastingForm: {
      _id: "",
      ageMax: "",
      ageMin: "",
      name: "",
      description: "",
      gender: "",
      notes: "",
      person: {
        isLoading: !1,
        results: null,
        selected: null
      },
      priority: "",
      status: "",
      type: "",
      isClient: ""
    }
  };
  var fn = {
    createProjectNote: "PROJECT_NOTES_CREATE_PROJECT_NOTES",
    loadProjectNote: "PROJECT_NOTES_LOAD_PROJECT_NOTE",
    loadProjectNotes: "PROJECT_NOTES_LOAD_PROJECT_NOTES",
    removeProjectNote: "PROJECT_NOTES_REMOVE_PROJECT_NOTES",
    setProjectNoteForm: "PROJECT_NOTES_SET_PROJECT_NOTES_FORM",
    updateProjectNote: "PROJECT_NOTES_UPDATE_PROJECT_NOTES",
    updateProjectNoteForm: "PROJECT_NOTES_UPDATE_PROJECT_NOTES_FORM"
  };

  function mn(e) {
    return ne(fn.loadProjectNotes, "/project_note", "GET", null, [{
      projectId: e
    }, {
      $populate: "personId"
    }, {
      $populate: "projectId"
    }, {
      "$sort[created]": -1
    }]);
  }

  function gn(e) {
    return F.get(fn.loadProjectNote, e, [{
      $populate: "personId"
    }, {
      $populate: "projectId"
    }]);
  }

  function vn(e) {
    return F.create(fn.createProjectNote, e, []);
  }

  function yn(e) {
    return F.delete(fn.removeProjectNote, e);
  }

  function En(e, t) {
    return F.update(fn.updateProjectNote, e, t);
  }

  function _n(e, t) {
    return function (n) {
      n({
        type: fn.updateProjectNoteForm,
        field: e,
        value: t
      });
    };
  }

  function hn(e) {
    return {
      type: fn.setProjectNoteForm,
      projectNoteForm: {
        _id: e._id,
        _person: e.personId,
        note: e.note,
        type: e.type,
        person: {
          isLoading: !1,
          results: null,
          selected: null
        }
      }
    };
  }

  var Tn = {
    projectNote: null,
    projectNotes: [],
    isLoading: !1,
    projectNoteForm: {
      _id: "",
      note: "",
      type: ""
    }
  };
  var Cn = {
    createProjectTracking: "PROJECT_TRACKING_CREATE_PROJECT_TRACKING",
    removeProjectTracking: "PROJECT_TRACKING_REMOVE_PROJECT_TRACKING",
    setProjectTrackingForm: "PROJECT_TRACKING_SET_PROJECT_TRACKING_FORM",
    updateProjectTracking: "PROJECT_TRACKING_UPDATE_PROJECT_TRACKING",
    updateProjectTrackingForm: "PROJECT_TRACKING_UPDATE_PROJECT_TRACKING_FORM"
  };

  function Pn(e) {
    return U.create(Cn.createProjectTracking, e, []);
  }

  function Rn(e) {
    return U.delete(Cn.removeProjectTracking, e);
  }

  function Sn(e, t) {
    return U.update(Cn.updateProjectTracking, e, t);
  }

  function bn(e, t) {
    return function (n) {
      n({
        type: Cn.updateProjectTrackingForm,
        field: e,
        value: t
      });
    };
  }

  function On(e) {
    return {
      type: Cn.setProjectTrackingForm,
      projectTrackingForm: {
        _id: e._id,
        _person: e.personId,
        description: e.description,
        jobName: e.jobName,
        listType: e.listType,
        note: e.note,
        person: {
          isLoading: !1,
          results: null,
          selected: null
        },
        updated: e.updated
      }
    };
  }

  var An = {
    projectTracking: null,
    projectTrackings: [],
    isLoading: !1,
    projectTrackingForm: {
      _id: "",
      description: "",
      jobName: "",
      listType: "",
      note: "",
      person: {
        isLoading: !1,
        results: null,
        selected: null
      }
    }
  };
  var Ln = {
    addRole: "PROJECT_ADD_ROLE",
    addScript: "PROJECT_ADD_SCRIPT",
    addSubmission: "PROJECT_ADD_SUBMISSION",
    createProject: "PROJECT_CREATE_PROJECT",
    loadProject: "PROJECT_LOAD_PROJECT",
    loadProjects: "PROJECT_LOAD_PROJECTS",
    loadRole: "PROJECT_LOAD_ROLE",
    loadScript: "PROJECT_LOAD_SCRIPT",
    loadSubmissions: "PROJECT_LOAD_SUBMISSIONS",
    removeRole: "PROJECT_REMOVE_ROLE",
    removeScript: "PROJECT_REMOVE_SCRIPT",
    removeSubmission: "PROJECT_REMOVE_SUBMISSION",
    searchCompany: "SEARCH_COMPANY",
    searchPerson: "SEARCH_PERSON",
    searchProject: "SEARCH_PROJECT",
    setProjects: "PROJECT_SET_PROJECTS",
    setRoleForm: "PROJECT_SET_ROLE_FORM",
    setScriptForm: "PROJECT_SET_SCRIPT_FORM",
    setSubmissionForm: "PROJECT_SET_SUBMISSION_FORM",
    updateForm: "PROJECT_UPDATE_FORM",
    updateProject: "PROJECT_UPDATE_PROJECT",
    updateRole: "PROJECT_UPDATE_ROLE",
    updateRoleForm: "PROJECT_UPDATE_ROLE_FORM",
    updateScript: "PROJECT_UPDATE_SCRIPT",
    updateScriptForm: "PROJECT_UPDATE_SCRIPT_FORM",
    updateSubmission: "PROJECT_UPDATE_SUBMISSION",
    updateSubmissionForm: "PROJECT_UPDATE_SUBMISSION_FORM"
  };

  function In(e, t) {
    var n = "name:".concat(e, "&");
    t && (n += "type=" + t);
    var r = [{
      $filter: n
    }];
    return ne(Ln.searchPerson, "/person", "GET", null, r);
  }

  function Dn(e) {
    var t = [{
      $search: "name:".concat(e)
    }];
    return ne(Ln.searchProject, "/project", "GET", null, t);
  }

  function jn(e) {
    var t = [{
      $search: "name:".concat(e)
    }];
    return ne(Ln.searchCompany, "/company", "GET", null, t);
  }

  function wn(e) {
    return j.get(Ln.loadProject, e, [{
      $populate: "literaryAgents"
    }, {
      $populate: "networks"
    }, {
      $populate: "productionCompany"
    }, {
      $populate: "productionCompanies"
    }, {
      $populate: "studios"
    }, {
      $populate: "talentAgents"
    }, {
      $populate: "agents"
    }, {
      $populate: "castings"
    }, {
      $populate: "castings.personId"
    }, {
      $populate: "trackings"
    }, {
      $populate: "trackings.personId"
    }]);
  }

  function Fn(e) {
    return j.list(Ln.loadProjects, e);
  }

  function Nn(e) {
    return ne(Ln.loadRole, "/project_role", "GET", null, [{
      projectId: e
    }, {
      $populate: "personId"
    }, {
      $populate: "projectId"
    }, {
      "$sort[type]": 1
    }]);
  }

  function kn(e) {
    return ne(Ln.loadScript, "/project_script", "GET", null, [{
      projectId: e
    }, {
      $populate: "contactId"
    }, {
      $populate: "projectId"
    }]);
  }

  function qn(e) {
    return ne(Ln.loadSubmissions, "/project_submission", "GET", null, [{
      projectId: e
    }, {
      $populate: "castingId"
    }, {
      $populate: "personId"
    }, {
      $populate: "projectId"
    }]);
  }

  function Un(e, t) {
    return function (n, r) {
      n({
        type: Ln.updateRoleForm,
        field: e,
        value: t
      });
    };
  }

  function Jn(e, t) {
    return function (n, r) {
      n({
        type: Ln.updateSubmissionForm,
        field: e,
        value: t
      });
    };
  }

  function xn(e, t) {
    return function (n, r) {
      n({
        type: Ln.updateScriptForm,
        field: e,
        value: t
      });
    };
  }

  function $n(e) {
    return {
      type: Ln.setSubmissionForm,
      projectSubmissionForm: {
        _id: e._id,
        status: e.status,
        person: e.personId,
        casting: e.castingId,
        castingId: e.castingId ? e.castingId._id : "",
        castingName: e.castingId ? e.castingId.name : "",
        note: e.note
      }
    };
  }

  function Mn(e) {
    return {
      type: Ln.setRoleForm,
      projectRoleForm: {
        _id: e._id,
        status: e.status,
        person: e.personId,
        notes: e.notes,
        type: e.type,
        isClient: e.isClient
      }
    };
  }

  function Gn(e) {
    return {
      type: Ln.setScriptForm,
      projectScriptForm: {
        _id: e._id,
        type: e.type,
        url: e.url,
        contact: e.contactId,
        version: e.version,
        title: e.title,
        format: e.format
      }
    };
  }

  function Hn(e, t) {
    return function (n, r) {
      n({
        type: Ln.updateForm,
        field: e,
        value: t
      });
    };
  }

  function Vn(e) {
    return N.create(Ln.addRole, e);
  }

  function Bn(e, t) {
    return j.update(Ln.updateProject, e, t);
  }

  function Wn(e, t) {
    return N.update(Ln.updateRole, e, t);
  }

  function zn(e, t) {
    return q.update(Ln.updateSubmission, e, t);
  }

  function Qn(e, t) {
    return k.update(Ln.updateScript, e, t);
  }

  function Kn(e, t) {
    return function (n, r) {
      r().projects.castings;
      n(w.update(Ln.updateCasting, e, t));
    };
  }

  function Yn(e) {
    return w.delete(Ln.removeCasting, e);
  }

  function Zn(e) {
    return q.delete(Ln.removeSubmission, e);
  }

  function Xn(e) {
    return k.delete(Ln.removeScript, e);
  }

  function er(e) {
    return N.delete(Ln.removeCasting, e);
  }

  function tr(e) {
    return j.create(Ln.createProject, e, []);
  }

  var nr = {
    project: null,
    castings: [],
    roles: [],
    trackings: [],
    scripts: [],
    submissions: [],
    projects: [],
    projectCount: 0,
    projectFilters: {
      offset: 0,
      limit: 50
    },
    isLoading: !1,
    projectRoleForm: {
      type: "",
      status: "",
      notes: "",
      isClient: "no",
      person: {
        isLoading: !1,
        results: null,
        selected: null
      }
    },
    projectScriptForm: {
      contact: {
        isLoading: !1,
        results: null,
        selected: null
      },
      url: "",
      title: "",
      type: "",
      format: "",
      version: ""
    },
    projectSubmissionForm: {
      casting: {
        isLoading: !1,
        results: null,
        selected: null
      },
      status: "",
      notes: "",
      person: {
        isLoading: !1,
        results: null,
        selected: null
      }
    },
    projectForm: {
      medium: "",
      name: "",
      status: "",
      type: ""
    }
  };
  var rr = n(7),
      or = n.n(rr),
      ir = {
    roleList: "SCRIPTS_ROLE_LIST",
    roleCreate: "SCRIPTS_ROLE_CREATE",
    roleDetails: "SCRIPTS_ROLE_DETAILS",
    roleDelete: "SCRIPTS_ROLE_DELETE",
    roleUpdate: "SCRIPTS_ROLE_UPDATE",
    coverageRequestList: "SCRIPTS_COVERAGE_REQUEST_LIST",
    coverageRequestCreate: "SCRIPTS_COVERAGE_REQUEST_CREATE",
    coverageRequestDetails: "SCRIPTS_COVERAGE_REQUEST_DETAILS",
    coverageRequestDelete: "SCRIPTS_COVERAGE_REQUEST_DELETE",
    coverageRequestUpdate: "SCRIPTS_COVERAGE_REQUEST_UPDATE",
    coverageRequestAssignmentList: "SCRIPTS_COVERAGE_REQUEST_ASSIGNMENT_LIST",
    coverageRequestAddAssignment: "SCRIPTS_COVERAGE_REQUEST_ASSIGNMENT_CREATE",
    coverageRequestRemoveAssignment: "SCRIPTS_COVERAGE_REQUEST_ASSIGNMENT_DELETE",
    scriptsList: "SCRIPTS_SCRIPT_LIST",
    scriptDetails: "SCRIPTS_SCRIPT_DETAILS",
    scriptAttachmentList: "SCRIPTS_SCRIPT_ATTACHMENT_LIST",
    scriptAttachmentCreate: "SCRIPTS_SCRIPT_ATTACHMENT_CREATE",
    resourceList: "SCRIPTS_COVERAGE_RESOURCE_LIST",
    assignmentUpdate: "SCRIPTS_COVERAGE_ASSIGNMENT_UPDATE",
    scriptCreate: "SCRIPTS_SCRIPT_CREATE",
    scriptUpdate: "SCRIPTS_SCRIPT_UPDATE",
    scriptVersionCreate: "SCRIPTS_SCRIPT_VERSION_CREATE",
    scriptVersionUpdate: "SCRIPTS_SCRIPT_VERSION_UPDATE",
    scriptVersionList: "SCRIPTS_SCRIPT_VERSION_LIST"
  };

  function ar() {
    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
    return d(ir.roleList, "/script-coverage/roles", "GET", {
      isExecute: e
    });
  }

  function sr(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return d(ir.roleDetails, "/script-coverage/roles/".concat(e), "GET", {
      isExecute: t
    });
  }

  function cr(e) {
    return d(ir.roleCreate, "/script-coverage/roles", "POST", e);
  }

  function ur(e) {
    return d(ir.roleCreate, "/script-coverage/roles/".concat(e.id), "PUT", e);
  }

  function dr() {
    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
    return d(ir.coverageRequestList, "/script-coverage/requests", "GET", {
      isExecute: e
    });
  }

  function lr(e) {
    arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return d(ir.coverageRequestDetails, "/script-coverage/requests/".concat(e), "GET");
  }

  function pr(e) {
    return null == e._id ? d(ir.scriptCreate, "/script-coverage/scripts", "POST", e) : d(ir.scriptUpdate, "/script-coverage/scripts/".concat(e._id), "PUT", e);
  }

  function fr(e, t) {
    return null == t._id ? d(ir.scriptVersionCreate, "/script-coverage/scripts/".concat(e._id, "/versions"), "POST", t) : d(ir.scriptVersionUpdate, "/script-coverage/scripts/".concat(e._id, "/versions/").concat(t._id), "PUT", t);
  }

  function mr(e) {
    return d(ir.scriptVersionList, "/script-coverage/scripts/".concat(e._id, "/versions"), "GET");
  }

  function gr(e) {
    return d(ir.scriptAttachmentList, "/script-coverage/scripts/".concat(e._id, "/attachments"), "GET");
  }

  function vr(e, t) {
    return d(ir.scriptAttachmentCreate, "/script-coverage/scripts/".concat(e._id, "/attachments"), "POST", t);
  }

  function yr(e) {
    return null == e._id ? d(ir.coverageRequestDetails, "/script-coverage/requests", "POST", e) : d(ir.coverageRequestDetails, "/script-coverage/requests/".concat(e._id), "PUT", e);
  }

  function Er(e) {
    arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return d(ir.scriptsList, "/script-coverage/scripts/".concat(null != e && "" != e ? "?search=" + encodeURIComponent(e) : ""), "GET");
  }

  function _r(e) {
    arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return d(ir.scriptDetails, "/script-coverage/scripts/".concat(e), "GET");
  }

  function hr(e) {
    arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return function (t, n) {
      var r = or.a.coverageRequests.find(function (t) {
        return null != t.assignments && t.assignments.some(function (t) {
          return t.token === e;
        });
      });
      return Promise.resolve(t({
        type: ir.resourceList,
        body: null != r && r.resources,
        isLoading: !1
      }));
    };
  }

  function Tr(e) {
    return d(ir.coverageRequestAssignmentList, "/script-coverage/requests/".concat(e._id, "/assignments"), "GET");
  }

  function Cr(e, t) {
    return d(ir.coverageRequestAddAssignment, "/script-coverage/requests/".concat(e._id, "/assignments"), "POST", t);
  }

  function Pr(e, t) {
    return d(ir.coverageRequestRemoveAssignment, "/script-coverage/requests/".concat(e._id, "/assignments/").concat(t._id), "DELETE");
  }

  var Rr = {
    roleList: [],
    role: {
      id: "new",
      application: "scripts",
      name: "",
      groups: [],
      permissions: []
    },
    coverageRequests: [],
    coverageRequestDetail: {},
    isLoading: !0
  };
  var Sr = Object(r.combineReducers)({
    adGroups: function adGroups() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : m,
          t = arguments.length > 1 ? arguments[1] : void 0;
      if (t.isLoading) return u({}, e, {
        isLoading: t.isLoading
      });

      switch (t.type) {
        case l.search:
          return u({}, e, {
            groupList: t.body || [],
            isLoading: t.isLoading
          });

        case l.details:
          return u({}, e, {
            groupDetails: t.body || [],
            isLoading: t.isLoading
          });

        default:
          return e;
      }
    },
    admin: function admin() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : se,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case re.normalizeDesk:
          return u({}, e, {
            deskStatus: t.body ? u({}, t.body.data, {
              isLoading: t.isLoading
            }) : u({}, e.deskStatus, {
              isLoading: t.isLoading
            })
          });

        case re.phonesheetUtilization:
          return u({}, e, {
            phonesheetUtilization: t.body ? u({}, t.body.data, {
              isLoading: t.isLoading
            }) : u({}, e.phonesheetUtilization, {
              isLoading: t.isLoading
            })
          });

        default:
          return e;
      }
    },
    archive: function archive() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : fe,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case ce.listArchive:
          return u({}, e, {
            archives: t.body ? t.body.data : e.archives,
            archiveCount: t.body ? t.body.total : e.archiveCount
          });

        case ce.clearArchive:
          return u({}, e, {
            archives: [],
            archiveCount: 0
          });

        case ce.searchArchive:
          return u({}, e, {
            archives: t.body ? t.body.data : e.archives,
            isLoading: t.isLoading,
            archiveCount: t.body ? t.body.total : e.archiveCount
          });

        default:
          return e;
      }
    },
    callForm: function callForm() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ye,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case ve.updateForm:
          var n;
          return u({}, e, (c(n = {}, t.field, t.value), c(n, "edited", "notes" !== t.field || e.edited), n));

        case ve.clearPerson:
          return u({}, e, {
            person: ye.person,
            outlook: ye.outlook,
            contact: ye.contact,
            type: ye.type,
            info: ye.info
          });

        case ve.clearPersonSearch:
          return u({}, e, {
            person: u({}, e.person, {
              results: null
            }),
            outlook: ye.outlook
          });

        case ve.clearContactSearch:
          return u({}, e, {
            contact: u({}, e.contact, {
              results: null
            })
          });

        case ve.resetForm:
          return u({}, ye, {
            showForm: e.showForm,
            date: new Date()
          });

        case ve.searchResults:
          return u({}, e, {
            person: u({}, e.person, {
              selected: null,
              isLoading: t.isLoading,
              results: t.data ? t.data : []
            })
          });

        case ve.searchOutlook:
          return u({}, e, {
            outlook: {
              isLoading: t.isLoading,
              results: t.body && t.body.map(function (e) {
                return {
                  name: e.displayName,
                  companyName: e.companyName,
                  contacts: function (e) {
                    var t = [];
                    return e.emailAddresses.length > 0 && t.push({
                      contactType: "Email",
                      contact: e.emailAddresses[0].address
                    }), e.businessPhones.length > 0 && t.unshift({
                      contactType: "Office Phone",
                      contact: e.businessPhones[0]
                    }), e.homePhones.length > 0 && t.unshift({
                      contactType: "Home Phone",
                      contact: e.homePhones[0]
                    }), e.mobilePhone && t.unshift({
                      contactType: "Mobile Phone",
                      contact: e.mobilePhone
                    }), e.imAddresses.length > 0 && t.push({
                      contactType: "Message",
                      contact: e.imAddresses[0]
                    }), t;
                  }(e),
                  addresses: function (e) {
                    var t = [];
                    return ["homeAddress", "otherAddress", "businessAddress"].map(function (n) {
                      var r = "";

                      switch (n) {
                        case "homeAddress":
                          r = "Home";
                          break;

                        case "businessAddress":
                          r = "Work";
                          break;

                        default:
                          r = "Unknown";
                      }

                      e[n] && e[n].street && t.push({
                        address: e[n].street,
                        state: e[n].state,
                        city: e[n].city,
                        country: e[n].countryOrRegion,
                        zip: e[n].postalCode,
                        type: r
                      });
                    }), t;
                  }(e),
                  outlook: !0
                };
              })
            }
          });

        case ve.searchPrivate:
          return u({}, e, {
            person: u({}, e.person, {
              selected: null,
              isLoading: t.isLoading,
              results: t.body ? e.person.results ? e.person.results.concat(t.body) : t.body : e.person.results
            })
          });

        case ve.selectPerson:
          var r = t.person || t.body;
          return r ? u({}, e, {
            name: r.name,
            person: u({}, e.person, {
              selected: r,
              results: null
            }),
            outlook: u({}, e.outlook, {
              results: null
            }),
            contact: {
              results: r.contacts
            }
          }) : e;

        case ve.selectType:
          return u({}, e, {
            type: t.contactType
          });

        case ve.showForm:
          return u({}, e, {
            showForm: !e.showForm
          });

        case ve.searchContact:
          return u({}, e, {
            contact: {
              results: t.results,
              selected: null
            }
          });

        case ve.selectContact:
          return t.contact ? u({}, e, {
            contact: u({}, e.contact, {
              selected: t.contact,
              results: null
            }),
            type: t.contact.contactType,
            info: t.contact.contact
          }) : u({}, e, {
            contact: u({}, e.contact, {
              selected: null
            })
          });

        case ve.editCallTodo:
          return u({}, e, {
            editCallTodo: t.callTodo
          });

        default:
          return e;
      }
    },
    callTodo: function callTodo() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ge,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case ke.list:
          return t.isLoading ? u({}, e, {
            calls: u({}, e.calls, {
              isLoading: t.isLoading
            })
          }) : u({}, e, {
            calls: {
              callTodos: t.body ? t.body.data : [],
              total: t.body && t.body.total,
              limit: t.body && t.body.limit,
              skip: t.body && t.body.skip,
              isLoading: t.isLoading
            }
          });

        case ke.preview:
          return u({}, e, {
            preview: u({}, e.preview, {
              call: t.call,
              person: t.call ? t.call.recipientId : null
            })
          });

        case ke.loadHistory:
          return u({}, e, {
            preview: u({}, e.preview, {
              history: t.body ? t.body.data : e.preview.history
            })
          });

        case ke.loadPerson:
          return u({}, e, {
            preview: u({}, e.preview, {
              person: t.body ? t.body : e.preview.person,
              isLoading: t.isLoading
            })
          });

        default:
          return e;
      }
    },
    dashboard: function dashboard() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : nt,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case Ve.listPeople:
          return u({}, e, {
            people: t.body ? t.body.data : e.people,
            peopleCount: t.body ? t.body.total : e.peopleCount,
            peopleFilters: e.peopleFilters
          });

        case Ve.listCompany:
          return u({}, e, {
            companies: t.body ? t.body.data : e.companies,
            companyCount: t.body ? t.body.total : e.companyCount,
            companyFilters: e.companyFilters
          });

        case Ve.deletePeople:
          return He.notify.show("Deleted Person", "success"), u({}, e, {
            people: t.body ? e.people.filter(function (e) {
              return e._id !== t.body._id;
            }) : e.people,
            peopleCount: e.peopleCount - 1
          });

        case Ve.editCompany:
          return He.notify.show("Edited Company", "success"), u({}, e, {
            companies: t.body ? e.companies.map(function (e) {
              e._id !== t.body._id && (e = t.body);
            }) : e.companies
          });

        case Ve.deleteCompany:
          return He.notify.show("Deleted Company", "success"), u({}, e, {
            companies: t.body ? e.companies.filter(function (e) {
              return e._id !== t.body._id;
            }) : e.companies,
            companyCount: e.companyCount - 1
          });

        case Ve.createCompany:
          return He.notify.show("Created Company", "success"), u({}, e, {
            companies: t.body ? e.companies.concat(t.body) : e.companies,
            companyCount: e.companyCount + 1
          });

        case Ve.createPerson:
          return He.notify.show("Created Person", "success"), u({}, e, {
            people: t.body ? e.people.concat(t.body) : e.people,
            peopleCount: e.peopleCount + 1,
            createdId: t.body ? t.body._id : ""
          });

        case Ve.mergePerson:
          return He.notify.show("Merged People", "success"), u({}, e, {
            createdId: t.body ? t.body._id : ""
          });

        case Ve.uploadContacts:
          return u({}, e, {
            data: t.body && t.body.data ? t.body : {}
          });

        case Ve.searchPerson:
          return u({}, e, {
            person: u({}, e.person, {
              selected: null,
              isLoading: t.isLoading,
              results: t.body ? t.body.data : []
            })
          });

        default:
          return e;
      }
    },
    dataRequest: function dataRequest() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ut,
          t = arguments.length > 1 ? arguments[1] : void 0;
      if (t.isLoading) return u({}, e, {
        isLoading: !0
      });

      switch (t.type) {
        case rt.countNewDataRequests:
          return u({}, e, {
            newDataRequests: t.body ? t.body.total : e.newDataRequests
          });

        case rt.loadDataRequests:
          return u({}, e, {
            dataRequests: t.body ? t.body.data : [],
            total: dt(t, e, "total"),
            limit: dt(t, e, "limit"),
            skip: dt(t, e, "skip"),
            isLoading: t.isLoading
          });

        case rt.updateDataRequest:
          return u({}, e, {
            isLoading: t.isLoading,
            dataRequest: dt(t, e, "dataRequest")
          });

        default:
          return e;
      }
    },
    deployOptions: function deployOptions() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : lt;
      return arguments.length > 1 && arguments[1], e;
    },
    filters: function filters() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Et,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case ft.loadFilters:
          return u({}, e, {
            filters: t.body && t.body.data ? t.body.data.map(function (e) {
              return e.values ? e : u({}, e, {
                values: JSON.parse(e.values)
              });
            }) : e.filters
          });

        case ft.createFilter:
          return u({}, e);

        case ft.updateFilter:
          return t.body ? u({}, e, {
            filters: e.filters.map(function (e) {
              return e._id !== t.body._id ? e : u({}, t.body);
            })
          }) : e;

        case ft.setCurrentFilter:
          return u({}, e, {
            currentFilterIndex: e.filters.findIndex(function (e) {
              return e._id === t.newFilterId;
            })
          });

        default:
          return e;
      }
    },
    job: function job() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : St,
          t = arguments.length > 1 ? arguments[1] : void 0,
          n = u({}, e, {
        isLoading: t.isLoading
      });

      switch (t.type) {
        case _t.loadJob:
          n.job = t.body ? t.body : e.job;
          break;

        case _t.loadJobs:
          n.jobs = t.body ? t.body.data : e.jobs;
          break;

        case _t.updateJob:
          t.isLoading ? n.job = u({}, e.job, t.payload) : n.job = t.body ? t.body : e.job;
      }

      return n;
    },
    portal: function portal() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : At,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case Ot.searchEmployee:
          return u({}, e, {
            employees: u({}, e.person, {
              selected: null,
              isLoading: t.isLoading,
              results: t.body ? t.body.offset > 0 ? M.orderBy(e.employees.results.concat(t.body.data), [function (e) {
                return e.name.split(" ")[1];
              }, function (e) {
                return e.name.split(" ")[0];
              }], ["asc", "asc"]) : M.orderBy(t.body.data, [function (e) {
                return e.name.split(" ")[1];
              }, function (e) {
                return e.name.split(" ")[0];
              }], ["asc", "asc"]) : M.orderBy(e.employees.results, [function (e) {
                return e.name.split(" ")[1];
              }, function (e) {
                return e.name.split(" ")[0];
              }], ["asc", "asc"])
            })
          });

        case Ot.searchContact:
          return u({}, e, {
            contacts: u({}, e.person, {
              selected: null,
              isLoading: t.isLoading,
              results: t.body ? t.body.data : []
            })
          });

        default:
          return e;
      }
    },
    profile: function profile() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : tn,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case Nt.listCalls:
          return u({}, e, {
            calls: t.body ? t.body.data : e.calls
          });

        case Nt.listHistory:
          return u({}, e, {
            history: t.body ? t.body.data : e.history
          });

        case Nt.loadPerson:
          return u({}, e, {
            isLoading: t.isLoading,
            person: t.body ? t.body : e.person,
            relationships: [],
            calls: [],
            history: []
          });

        case Nt.loadRelation:
          return u({}, e, {
            relationships: t.relationships
          });

        case Nt.updatePerson:
          return t.isLoading ? u({}, e, {
            person: u({}, e.person, t.payload),
            isLoading: !0
          }) : u({}, e, {
            isLoading: t.isLoading,
            person: t.body ? t.body : e.person
          });

        default:
          return e;
      }
    },
    projectCastings: function projectCastings() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : pn,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case rn.loadProjectCasting:
          return u({}, e, {
            isLoading: t.isLoading,
            projectCasting: t.body ? t.body : e.projectCasting
          });

        case rn.loadProjectCastings:
          return u({}, e, {
            projectCastings: t.body ? t.body.data : e.projectCastings
          });

        case rn.setProjectCastingForm:
          return u({}, e, {
            projectCastingForm: t.projectCastingForm
          });

        case rn.updateProjectCasting:
          return t.isLoading ? u({}, e, {
            projectCasting: u({}, e.projectCasting, t.payload),
            isLoading: !0
          }) : u({}, e, {
            isLoading: t.isLoading,
            projectCasting: t.body ? t.body : e.projectCasting
          });

        case rn.updateProjectCastingForm:
          return u({}, e, {
            projectCastingForm: u({}, e.projectCastingForm, c({}, t.field, t.value))
          });

        default:
          return e;
      }
    },
    projectNotes: function projectNotes() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Tn,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case fn.loadProjectNote:
          return u({}, e, {
            isLoading: t.isLoading,
            projectNote: t.body ? t.body : e.projectNote
          });

        case fn.loadProjectNotes:
          return u({}, e, {
            projectNotes: t.body ? t.body.data : e.projectNotes
          });

        case fn.setProjectNoteForm:
          return u({}, e, {
            projectNoteForm: t.projectNoteForm
          });

        case fn.updateProjectNote:
          return t.isLoading ? u({}, e, {
            projectNote: u({}, e.projectNote, t.payload),
            isLoading: !0
          }) : u({}, e, {
            isLoading: t.isLoading,
            projectNote: t.body ? t.body : e.projectNote
          });

        case fn.updateProjectNoteForm:
          return u({}, e, {
            projectNoteForm: u({}, e.projectNoteForm, c({}, t.field, t.value))
          });

        default:
          return e;
      }
    },
    projectTrackings: function projectTrackings() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : An,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case Cn.setProjectTrackingForm:
          return u({}, e, {
            projectTrackingForm: t.projectTrackingForm
          });

        case Cn.updateProjectTracking:
          return t.isLoading ? u({}, e, {
            projectTracking: u({}, e.projectTracking, t.payload),
            isLoading: !0
          }) : u({}, e, {
            isLoading: t.isLoading,
            projectTracking: t.body ? t.body : e.projectTracking
          });

        case Cn.updateProjectTrackingForm:
          return u({}, e, {
            projectTrackingForm: u({}, e.projectTrackingForm, c({}, t.field, t.value))
          });

        default:
          return e;
      }
    },
    projects: function projects() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : nr,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case Ln.setProjects:
          return u({}, e, {
            projects: t.projects ? t.projects : e.projects
          });

        case Ln.loadProjects:
          return u({}, e, {
            isLoading: t.isLoading,
            projects: t.body ? t.body.data : e.projects,
            projectCount: t.body ? t.body.total : e.projectCount,
            projectPagination: e.projectFilters
          });

        case Ln.searchProject:
          return u({}, e, {
            isLoading: t.isLoading,
            projects: t.body ? t.body.data : e.projects
          });

        case Ln.loadProject:
          return t.body && t.body.castings.sort(function (e, t) {
            return e.priority - t.priority;
          }), t.body && t.body.trackings.sort(function (e, t) {
            return t.updated - e.updated;
          }), u({}, e, {
            isLoading: t.isLoading,
            project: t.body ? t.body : e.project
          });

        case Ln.updateProject:
          return t.isLoading ? u({}, e, {
            project: u({}, e.project, t.payload),
            isLoading: !0
          }) : u({}, e, {
            isLoading: t.isLoading,
            project: t.body ? t.body : e.project
          });

        case Ln.loadCastings:
          return u({}, e, {
            castings: t.body ? t.body.data : e.castings
          });

        case Ln.loadRole:
          return u({}, e, {
            roles: t.body ? t.body.data : e.roles
          });

        case Ln.loadSubmissions:
          return u({}, e, {
            submissions: t.body ? t.body.data : e.submissions
          });

        case Ln.loadScript:
          return u({}, e, {
            scripts: t.body ? t.body.data : e.scripts
          });

        case Ln.updateRoleForm:
          return u({}, e, {
            projectRoleForm: u({}, e.projectRoleForm, c({}, t.field, t.value))
          });

        case Ln.updateSubmissionForm:
          return u({}, e, {
            projectSubmissionForm: u({}, e.projectSubmissionForm, c({}, t.field, t.value))
          });

        case Ln.updateScriptForm:
          return u({}, e, {
            projectScriptForm: u({}, e.projectScriptForm, c({}, t.field, t.value))
          });

        case Ln.updateForm:
          return u({}, e, {
            projectForm: u({}, e.projectForm, c({}, t.field, t.value))
          });

        case Ln.setRoleForm:
          return u({}, e, {
            projectRoleForm: t.projectRoleForm
          });

        case Ln.setSubmissionForm:
          return u({}, e, {
            projectSubmissionForm: t.projectSubmissionForm
          });

        case Ln.setScriptForm:
          return u({}, e, {
            projectScriptForm: t.projectScriptForm
          });

        default:
          return e;
      }
    },
    scripts: function scripts() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Rr,
          t = arguments.length > 1 ? arguments[1] : void 0;
      if (t.isLoading) return u({}, e, {
        isLoading: t.isLoading
      });

      switch (t.type) {
        case ir.roleList:
          return u({}, e, {
            roleList: t.body || [],
            isLoading: t.isLoading
          });

        case ir.roleDetails || ir.roleCreate:
          return u({}, e, {
            role: t.body || {},
            isLoading: t.isLoading
          });

        case ir.coverageRequestList:
          return u({}, e, {
            coverageRequests: t.body || {},
            isLoading: t.isLoading
          });

        case ir.coverageRequestDetails:
          return u({}, e, {
            coverageRequest: t.body || {},
            isLoading: t.isLoading
          });

        case ir.scriptsList:
          return u({}, e, {
            searchResults: t.body || [],
            isLoading: t.isLoading
          });

        case ir.resourceList:
          return u({}, e, {
            resources: t.body || [],
            isLoading: t.isLoading
          });

        case ir.assignmentUpdate:
        case ir.scriptCreate:
        case ir.scriptDetails:
        case ir.scriptVersionCreate:
        case ir.scriptVersionList:
          return u({}, e, {
            isLoading: t.isLoading
          });

        default:
          return e;
      }
    },
    user: function user() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : te,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case H.login:
          return u({}, e);

        case H.status:
        case H.editStatus:
          return u({}, e, {
            isLoading: t.isLoading,
            status: t.body ? M.orderBy(t.body.data, ["order"], ["asc"]) : []
          });

        case H.moveStatus:
          return u({}, e, {
            status: Object(G.arrayMove)(e.status, t.oldIndex, t.newIndex)
          });

        case H.updateStatus:
          return u({}, e, {
            status: e.status.map(function (e, n) {
              return n === t.index ? (e[t.field] = t.value, e) : e;
            })
          });

        case H.updateDeskSettings:
          var n = t.body ? t.body : e.desk;
          return e.user.deskIds.filter(function (e) {
            return e._id === n._id;
          })[0].settings = n.settings, u({}, e, {
            desk: n
          });

        case H.invalidate:
          return {
            user: null
          };

        case H.loadUser:
          return u({}, e, {
            isLoading: t.isLoading,
            user: t.body ? u({}, e.user, t.body) : e.user
          });

        case H.setDesk:
          return u({}, e, {
            desk: t.desk
          });

        case H.setAuth:
          return u({}, e, {
            user: u({}, e.user, {
              auth: t.auth
            })
          });

        default:
          return e;
      }
    }
  }),
      br = (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || r.compose)(Object(r.applyMiddleware)(i.a, s.a));

  function Or(e) {
    var t = new URLSearchParams(window.location.search);
    t.has("token") && localStorage.setItem("uta.auth", t.get("token"));
    var n = {
      user: {
        user: {
          auth: localStorage["uta.auth"],
          authorization: {
            scripts: localStorage["scripts.authorization"]
          }
        }
      },
      deployOptions: e
    };
    return Object(r.createStore)(Sr, n, br);
  }

  var Ar = {
    set: "SET_CURRENT_NOTES"
  };

  function Lr(e) {
    return function (t) {
      t({
        type: Ar.set,
        notes: e
      });
    };
  }

  var Ir = {
    searchLogs: "SEARCH_LOGS",
    searchPersons: "SEARCH_PERSONS"
  };

  function Dr(e) {
    return function () {
      var t = E(v.a.mark(function t(n) {
        return v.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, n(jr(e));

              case 2:
                return t.sent, t.next = 5, n(wr(e));

              case 5:
                t.sent;

              case 6:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function jr(e) {
    return P.list(Ir.searchLogs, [{
      $populate: "recipientId"
    }, {
      $populate: "contactId"
    }, {
      $limit: 10
    }, {
      "$sort[occurrence_date]": -1
    }, {
      $search: "contactInfo|notes"
    }]);
  }

  function wr(e) {
    return function (e) {
      var t = [{
        $populate: "contacts"
      }, {
        $populate: "companyId"
      }, {
        "type[$ne]": bt.shared
      }];
      e(D.search(Ir.searchPerson, t));
    };
  }

  function Fr(e, t, n, r, o, i) {
    return Nr.apply(this, arguments);
  }

  function Nr() {
    return (Nr = E(v.a.mark(function e(t, n, r, o, i, a) {
      var s,
          c,
          u,
          d,
          l,
          p,
          f,
          m,
          g = arguments;
      return v.a.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return s = g.length > 6 && void 0 !== g[6] ? g[6] : "application/json", c = "GET" !== o, u = a && a.map(function (e) {
                return "".concat(Object.keys(e)[0], "=").concat(Object.values(e)[0]);
              }).join("&"), d = a ? r + "?" + u : r, l = "".concat(n).concat(d), p = c ? JSON.stringify(i) : void 0, f = {
                Authorization: "JWT " + t.auth,
                Accept: s,
                "Content-Type": s
              }, e.next = 9, window.fetch(l, {
                method: o,
                body: p,
                headers: new Headers(f),
                mode: "cors",
                cache: "default",
                redirect: "follow"
              });

            case 9:
              if (m = e.sent, "application/pdf" !== s && "text/csv" !== s) {
                e.next = 14;
                break;
              }

              return e.abrupt("return", m);

            case 14:
              return e.abrupt("return", m.json());

            case 15:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }))).apply(this, arguments);
  }

  n.d(t, "createStoreWithOptions", function () {
    return Or;
  }), n.d(t, "adGroupSearch", function () {
    return f;
  }), n.d(t, "adGroupDetails", function () {
    return p;
  }), n.d(t, "normalizeDesks", function () {
    return oe;
  }), n.d(t, "phonesheetUtilization", function () {
    return ie;
  }), n.d(t, "recordEvent", function () {
    return ae;
  }), n.d(t, "searchArchive", function () {
    return ue;
  }), n.d(t, "listArchive", function () {
    return de;
  }), n.d(t, "updateArchive", function () {
    return le;
  }), n.d(t, "clearArchive", function () {
    return pe;
  }), n.d(t, "updateForm", function () {
    return Ee;
  }), n.d(t, "showForm", function () {
    return _e;
  }), n.d(t, "clearPerson", function () {
    return he;
  }), n.d(t, "clearPersonSearch", function () {
    return Te;
  }), n.d(t, "clearContactSearch", function () {
    return Ce;
  }), n.d(t, "resetForm", function () {
    return Pe;
  }), n.d(t, "searchPerson", function () {
    return Re;
  }), n.d(t, "searchContact", function () {
    return Se;
  }), n.d(t, "selectPerson", function () {
    return be;
  }), n.d(t, "selectType", function () {
    return Oe;
  }), n.d(t, "selectContact", function () {
    return Ae;
  }), n.d(t, "editCall", function () {
    return Le;
  }), n.d(t, "createPerson", function () {
    return Ie;
  }), n.d(t, "createCompany", function () {
    return De;
  }), n.d(t, "updatePerson", function () {
    return je;
  }), n.d(t, "createAddress", function () {
    return we;
  }), n.d(t, "createContact", function () {
    return Fe;
  }), n.d(t, "listHistory", function () {
    return qe;
  }), n.d(t, "listCalls", function () {
    return Ue;
  }), n.d(t, "createCall", function () {
    return Je;
  }), n.d(t, "updateCall", function () {
    return xe;
  }), n.d(t, "deleteCall", function () {
    return $e;
  }), n.d(t, "previewCall", function () {
    return Me;
  }), n.d(t, "searchPersonDashboard", function () {
    return Be;
  }), n.d(t, "listPeople", function () {
    return We;
  }), n.d(t, "listCompany", function () {
    return ze;
  }), n.d(t, "saveCompany", function () {
    return Qe;
  }), n.d(t, "mergePerson", function () {
    return Ke;
  }), n.d(t, "savePerson", function () {
    return Ye;
  }), n.d(t, "editCompany", function () {
    return Ze;
  }), n.d(t, "deletePerson", function () {
    return Xe;
  }), n.d(t, "deleteCompany", function () {
    return et;
  }), n.d(t, "uploadContacts", function () {
    return tt;
  }), n.d(t, "countNewDataRequests", function () {
    return ot;
  }), n.d(t, "createDataRequest", function () {
    return it;
  }), n.d(t, "loadDataRequests", function () {
    return at;
  }), n.d(t, "removeDataRequest", function () {
    return st;
  }), n.d(t, "updateDataRequest", function () {
    return ct;
  }), n.d(t, "loadFilters", function () {
    return mt;
  }), n.d(t, "createFilter", function () {
    return gt;
  }), n.d(t, "updateFilter", function () {
    return vt;
  }), n.d(t, "setCurrentFilter", function () {
    return yt;
  }), n.d(t, "createJob", function () {
    return ht;
  }), n.d(t, "loadJob", function () {
    return Tt;
  }), n.d(t, "loadJobs", function () {
    return Ct;
  }), n.d(t, "removeJob", function () {
    return Pt;
  }), n.d(t, "updateJob", function () {
    return Rt;
  }), n.d(t, "setNotes", function () {
    return Lr;
  }), n.d(t, "searchEmployee", function () {
    return It;
  }), n.d(t, "searchContactPortal", function () {
    return Lt;
  }), n.d(t, "findPersonPoral", function () {
    return Dt;
  }), n.d(t, "addAddress", function () {
    return kt;
  }), n.d(t, "addContact", function () {
    return qt;
  }), n.d(t, "addRelation", function () {
    return Ut;
  }), n.d(t, "listByPerson1", function () {
    return Jt;
  }), n.d(t, "listByPerson2", function () {
    return xt;
  }), n.d(t, "listCallsProfile", function () {
    return $t;
  }), n.d(t, "listHistoryProfile", function () {
    return Mt;
  }), n.d(t, "loadPerson", function () {
    return Gt;
  }), n.d(t, "loadRelation", function () {
    return Ht;
  }), n.d(t, "publishToContentful", function () {
    return Vt;
  }), n.d(t, "removeAddress", function () {
    return Bt;
  }), n.d(t, "removeContact", function () {
    return Wt;
  }), n.d(t, "removeRelation", function () {
    return zt;
  }), n.d(t, "searchCompany", function () {
    return Qt;
  }), n.d(t, "searchPersonProfile", function () {
    return Kt;
  }), n.d(t, "updateAddress", function () {
    return Yt;
  }), n.d(t, "updateContact", function () {
    return Zt;
  }), n.d(t, "updatePersonProfile", function () {
    return en;
  }), n.d(t, "updateRelation", function () {
    return Xt;
  }), n.d(t, "loadProjectCastings", function () {
    return on;
  }), n.d(t, "loadProjectCasting", function () {
    return an;
  }), n.d(t, "createProjectCasting", function () {
    return sn;
  }), n.d(t, "removeProjectCasting", function () {
    return cn;
  }), n.d(t, "updateProjectCasting", function () {
    return un;
  }), n.d(t, "updateProjectCastingForm", function () {
    return dn;
  }), n.d(t, "setProjectCastingForm", function () {
    return ln;
  }), n.d(t, "loadProjectNotes", function () {
    return mn;
  }), n.d(t, "loadProjectNote", function () {
    return gn;
  }), n.d(t, "createProjectNote", function () {
    return vn;
  }), n.d(t, "removeProjectNote", function () {
    return yn;
  }), n.d(t, "updateProjectNote", function () {
    return En;
  }), n.d(t, "updateProjectNoteForm", function () {
    return _n;
  }), n.d(t, "setProjectNoteForm", function () {
    return hn;
  }), n.d(t, "createProjectTracking", function () {
    return Pn;
  }), n.d(t, "removeProjectTracking", function () {
    return Rn;
  }), n.d(t, "updateProjectTracking", function () {
    return Sn;
  }), n.d(t, "updateProjectTrackingForm", function () {
    return bn;
  }), n.d(t, "setProjectTrackingForm", function () {
    return On;
  }), n.d(t, "searchPersonProject", function () {
    return In;
  }), n.d(t, "searchProjects", function () {
    return Dn;
  }), n.d(t, "searchCompanyProject", function () {
    return jn;
  }), n.d(t, "loadProject", function () {
    return wn;
  }), n.d(t, "loadProjects", function () {
    return Fn;
  }), n.d(t, "loadRoles", function () {
    return Nn;
  }), n.d(t, "loadScripts", function () {
    return kn;
  }), n.d(t, "loadSubmissions", function () {
    return qn;
  }), n.d(t, "updateRoleForm", function () {
    return Un;
  }), n.d(t, "updateSubmissionForm", function () {
    return Jn;
  }), n.d(t, "updateScriptForm", function () {
    return xn;
  }), n.d(t, "setSubmissionForm", function () {
    return $n;
  }), n.d(t, "setRoleForm", function () {
    return Mn;
  }), n.d(t, "setScriptForm", function () {
    return Gn;
  }), n.d(t, "updateProjectForm", function () {
    return Hn;
  }), n.d(t, "updateProject", function () {
    return Bn;
  }), n.d(t, "updateRole", function () {
    return Wn;
  }), n.d(t, "updateSubmission", function () {
    return zn;
  }), n.d(t, "createRole", function () {
    return Vn;
  }), n.d(t, "updateScript", function () {
    return Qn;
  }), n.d(t, "updateCasting", function () {
    return Kn;
  }), n.d(t, "removeCasting", function () {
    return Yn;
  }), n.d(t, "removeSubmission", function () {
    return Zn;
  }), n.d(t, "removeScript", function () {
    return Xn;
  }), n.d(t, "removeRole", function () {
    return er;
  }), n.d(t, "createProject", function () {
    return tr;
  }), n.d(t, "search", function () {
    return Dr;
  }), n.d(t, "redirectToAzure", function () {
    return V;
  }), n.d(t, "invalidateLogin", function () {
    return B;
  }), n.d(t, "loadUser", function () {
    return W;
  }), n.d(t, "setDesk", function () {
    return z;
  }), n.d(t, "updateDeskSettings", function () {
    return Q;
  }), n.d(t, "updateStatus", function () {
    return K;
  }), n.d(t, "editStatus", function () {
    return Y;
  }), n.d(t, "moveStatus", function () {
    return Z;
  }), n.d(t, "listStatus", function () {
    return X;
  }), n.d(t, "setAuth", function () {
    return ee;
  }), n.d(t, "roleList", function () {
    return ar;
  }), n.d(t, "roleDetails", function () {
    return sr;
  }), n.d(t, "roleCreate", function () {
    return cr;
  }), n.d(t, "roleUpdate", function () {
    return ur;
  }), n.d(t, "coverageRequestList", function () {
    return dr;
  }), n.d(t, "coverageRequestDetails", function () {
    return lr;
  }), n.d(t, "coverageRequestSave", function () {
    return yr;
  }), n.d(t, "scriptsList", function () {
    return Er;
  }), n.d(t, "scriptDetails", function () {
    return _r;
  }), n.d(t, "getReaderResources", function () {
    return hr;
  }), n.d(t, "assignmentUpdate", function () {}), n.d(t, "assignmentList", function () {
    return Tr;
  }), n.d(t, "assignmentAdd", function () {
    return Cr;
  }), n.d(t, "assignmentRemove", function () {
    return Pr;
  }), n.d(t, "scriptSave", function () {
    return pr;
  }), n.d(t, "scriptVersionSave", function () {
    return fr;
  }), n.d(t, "scriptVersionList", function () {
    return mr;
  }), n.d(t, "scriptAttachmentCreate", function () {
    return vr;
  }), n.d(t, "scriptAttachmentList", function () {
    return gr;
  }), n.d(t, "requestPromise", function () {
    return Fr;
  }), n.d(t, "personTypes", function () {
    return bt;
  });
}]));